/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ReportImport } from './routes/report'
import { Route as GuestImport } from './routes/_guest'
import { Route as BackofficeImport } from './routes/_backoffice'
import { Route as R403Import } from './routes/403'
import { Route as IndexImport } from './routes/index'
import { Route as AuthSignInImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as ReportPemetaanWilkerIndexImport } from './routes/report/pemetaan-wilker/index'
import { Route as GuestGuestIndexImport } from './routes/_guest/guest/index'
import { Route as BackofficeVerificationWilkerPenyuluhIndexImport } from './routes/_backoffice/verification-wilker-penyuluh/index'
import { Route as BackofficeVerificationDataIndexImport } from './routes/_backoffice/verification-data/index'
import { Route as BackofficeUserIndexImport } from './routes/_backoffice/user/index'
import { Route as BackofficeProfileIndexImport } from './routes/_backoffice/profile/index'
import { Route as BackofficeKlbPetaniIndexImport } from './routes/_backoffice/klb-petani/index'
import { Route as BackofficeEditPenyuluhIndexImport } from './routes/_backoffice/edit-penyuluh/index'
import { Route as BackofficeDashboardIndexImport } from './routes/_backoffice/dashboard/index'
import { Route as BackofficeAboutIndexImport } from './routes/_backoffice/about/index'
import { Route as OauthSimluhtanCallbackImport } from './routes/oauth/simluhtan/callback'
import { Route as GuestGuestRecapShapeKepImport } from './routes/_guest/guest/recap-shape-kep'
import { Route as GuestGuestRecapPoktanImport } from './routes/_guest/guest/recap-poktan'
import { Route as GuestGuestRecapFarmerInstitutionsImport } from './routes/_guest/guest/recap-farmer-institutions'
import { Route as GuestGuestRecapExtentionsWorkerImport } from './routes/_guest/guest/recap-extentions-worker'
import { Route as GuestGuestRecapExtensionsInstitutionsImport } from './routes/_guest/guest/recap-extensions-institutions'
import { Route as GuestGuestRecapClassificationsBppImport } from './routes/_guest/guest/recap-classifications-bpp'
import { Route as GuestGuestRecapClassPoktanImport } from './routes/_guest/guest/recap-class-poktan'
import { Route as GuestGuestListPoktanMemberImport } from './routes/_guest/guest/list-poktan-member'
import { Route as GuestGuestListPoktanImport } from './routes/_guest/guest/list-poktan'
import { Route as GuestGuestListKepImport } from './routes/_guest/guest/list-kep'
import { Route as GuestGuestListGapoktanImport } from './routes/_guest/guest/list-gapoktan'
import { Route as GuestGuestKtgWorkerListImport } from './routes/_guest/guest/ktg-worker-list'
import { Route as ReportPemetaanWilkerProvinsiIdIndexImport } from './routes/report/pemetaan-wilker/$provinsiId/index'
import { Route as GuestGuestExtensionsInstitutionsIndexImport } from './routes/_guest/guest/extensions-institutions/index'
import { Route as BackofficeVerificationDataVerificationIdIndexImport } from './routes/_backoffice/verification-data/$verificationId/index'
import { Route as BackofficeUserProvinsiIndexImport } from './routes/_backoffice/user/provinsi/index'
import { Route as BackofficeUserKabupatenIndexImport } from './routes/_backoffice/user/kabupaten/index'
import { Route as BackofficeUserBppIndexImport } from './routes/_backoffice/user/bpp/index'
import { Route as BackofficeUserAdminIndexImport } from './routes/_backoffice/user/admin/index'
import { Route as BackofficeKtgPenyuluhSwastaIndexImport } from './routes/_backoffice/ktg-penyuluh/swasta/index'
import { Route as BackofficeKtgPenyuluhSwadayaIndexImport } from './routes/_backoffice/ktg-penyuluh/swadaya/index'
import { Route as BackofficeKtgPenyuluhPnsPppkIndexImport } from './routes/_backoffice/ktg-penyuluh/pns-pppk/index'
import { Route as BackofficeKtgPenyuluhPindahDomisiliIndexImport } from './routes/_backoffice/ktg-penyuluh/pindah-domisili/index'
import { Route as BackofficeKtgPenyuluhApbnIndexImport } from './routes/_backoffice/ktg-penyuluh/apbn/index'
import { Route as BackofficeKtgPenyuluhApbdIndexImport } from './routes/_backoffice/ktg-penyuluh/apbd/index'
import { Route as BackofficeKlbPetaniPoktanIndexImport } from './routes/_backoffice/klb-petani/poktan/index'
import { Route as BackofficeKlbPetaniPetaniIndexImport } from './routes/_backoffice/klb-petani/petani/index'
import { Route as BackofficeKlbPetaniKepIndexImport } from './routes/_backoffice/klb-petani/kep/index'
import { Route as BackofficeKlbPetaniGapoktanIndexImport } from './routes/_backoffice/klb-petani/gapoktan/index'
import { Route as BackofficeKlbPetaniCariPetaniIndexImport } from './routes/_backoffice/klb-petani/cari-petani/index'
import { Route as BackofficeKlbPenyuluhPusatIndexImport } from './routes/_backoffice/klb-penyuluh/pusat/index'
import { Route as BackofficeKlbPenyuluhProvinsiIndexImport } from './routes/_backoffice/klb-penyuluh/provinsi/index'
import { Route as BackofficeKlbPenyuluhKotakabIndexImport } from './routes/_backoffice/klb-penyuluh/kotakab/index'
import { Route as BackofficeKlbPenyuluhKecamatanIndexImport } from './routes/_backoffice/klb-penyuluh/kecamatan/index'
import { Route as BackofficeKlbPenyuluhDesaIndexImport } from './routes/_backoffice/klb-penyuluh/desa/index'
import { Route as BackofficeEditPenyuluhSubmissionIndexImport } from './routes/_backoffice/edit-penyuluh/submission/index'
import { Route as BackofficeAboutCreateIndexImport } from './routes/_backoffice/about/create/index'
import { Route as GuestGuestSearchKtgExtensionsInstitutionsImport } from './routes/_guest/guest/search/ktg-extensions-institutions'
import { Route as GuestGuestSearchKlbFarmersImport } from './routes/_guest/guest/search/klb-farmers'
import { Route as GuestGuestSearchFarmerPoktanMembersImport } from './routes/_guest/guest/search/farmer-poktan-members'
import { Route as BackofficeUserProvinsiCreateImport } from './routes/_backoffice/user/provinsi/create'
import { Route as BackofficeUserKabupatenCreateImport } from './routes/_backoffice/user/kabupaten/create'
import { Route as BackofficeUserBppCreateImport } from './routes/_backoffice/user/bpp/create'
import { Route as BackofficeUserAdminCreateImport } from './routes/_backoffice/user/admin/create'
import { Route as BackofficeKlbPenyuluhKotakabCreateImport } from './routes/_backoffice/klb-penyuluh/kotakab/create'
import { Route as BackofficeKlbPenyuluhKecamatanCreateImport } from './routes/_backoffice/klb-penyuluh/kecamatan/create'
import { Route as BackofficeKlbPenyuluhDesaCreateImport } from './routes/_backoffice/klb-penyuluh/desa/create'
import { Route as ReportPemetaanWilkerProvinsiIdKotaIdIndexImport } from './routes/report/pemetaan-wilker/$provinsiId/$kotaId/index'
import { Route as BackofficeKtgPenyuluhSwastaCreateIndexImport } from './routes/_backoffice/ktg-penyuluh/swasta/create/index'
import { Route as BackofficeKtgPenyuluhSwastaSwastaIdIndexImport } from './routes/_backoffice/ktg-penyuluh/swasta/$swastaId/index'
import { Route as BackofficeKtgPenyuluhSwadayaCreateIndexImport } from './routes/_backoffice/ktg-penyuluh/swadaya/create/index'
import { Route as BackofficeKtgPenyuluhSwadayaSwadayaIdIndexImport } from './routes/_backoffice/ktg-penyuluh/swadaya/$swadayaId/index'
import { Route as BackofficeKtgPenyuluhPnsPppkCreateIndexImport } from './routes/_backoffice/ktg-penyuluh/pns-pppk/create/index'
import { Route as BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexImport } from './routes/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/index'
import { Route as BackofficeKtgPenyuluhApbnCreateIndexImport } from './routes/_backoffice/ktg-penyuluh/apbn/create/index'
import { Route as BackofficeKtgPenyuluhApbnApbnIdIndexImport } from './routes/_backoffice/ktg-penyuluh/apbn/$apbnId/index'
import { Route as BackofficeKtgPenyuluhApbdCreateIndexImport } from './routes/_backoffice/ktg-penyuluh/apbd/create/index'
import { Route as BackofficeKtgPenyuluhApbdApbdIdIndexImport } from './routes/_backoffice/ktg-penyuluh/apbd/$apbdId/index'
import { Route as BackofficeKlbPetaniPoktanSubmissionIndexImport } from './routes/_backoffice/klb-petani/poktan/submission/index'
import { Route as BackofficeKlbPetaniPoktanCreateIndexImport } from './routes/_backoffice/klb-petani/poktan/create/index'
import { Route as BackofficeKlbPetaniPoktanPoktanIdIndexImport } from './routes/_backoffice/klb-petani/poktan/$poktanId/index'
import { Route as BackofficeKlbPetaniPetaniSubmissionIndexImport } from './routes/_backoffice/klb-petani/petani/submission/index'
import { Route as BackofficeKlbPetaniPetaniCreateIndexImport } from './routes/_backoffice/klb-petani/petani/create/index'
import { Route as BackofficeKlbPetaniPetaniPetaniIdIndexImport } from './routes/_backoffice/klb-petani/petani/$petaniId/index'
import { Route as BackofficeKlbPetaniKepSubmissionIndexImport } from './routes/_backoffice/klb-petani/kep/submission/index'
import { Route as BackofficeKlbPetaniKepCreateIndexImport } from './routes/_backoffice/klb-petani/kep/create/index'
import { Route as BackofficeKlbPetaniKepKepIdIndexImport } from './routes/_backoffice/klb-petani/kep/$kepId/index'
import { Route as BackofficeKlbPetaniGapoktanSubmissionIndexImport } from './routes/_backoffice/klb-petani/gapoktan/submission/index'
import { Route as BackofficeKlbPetaniGapoktanCreateIndexImport } from './routes/_backoffice/klb-petani/gapoktan/create/index'
import { Route as BackofficeKlbPetaniGapoktanGapoktanIdIndexImport } from './routes/_backoffice/klb-petani/gapoktan/$gapoktanId/index'
import { Route as BackofficeKlbPetaniCariPetaniCariPetaniIdIndexImport } from './routes/_backoffice/klb-petani/cari-petani/$cariPetaniId/index'
import { Route as BackofficeKlbPenyuluhPusatCreateIndexImport } from './routes/_backoffice/klb-penyuluh/pusat/create/index'
import { Route as BackofficeKlbPenyuluhPusatPusatIdIndexImport } from './routes/_backoffice/klb-penyuluh/pusat/$pusatId/index'
import { Route as BackofficeKlbPenyuluhProvinsiCreateIndexImport } from './routes/_backoffice/klb-penyuluh/provinsi/create/index'
import { Route as BackofficeKlbPenyuluhProvinsiProvinsiIdIndexImport } from './routes/_backoffice/klb-penyuluh/provinsi/$provinsiId/index'
import { Route as BackofficeKlbPenyuluhKotakabKotakabIdIndexImport } from './routes/_backoffice/klb-penyuluh/kotakab/$kotakabId/index'
import { Route as BackofficeKlbPenyuluhKecamatanBppIdIndexImport } from './routes/_backoffice/klb-penyuluh/kecamatan/$bppId/index'
import { Route as BackofficeEditPenyuluhSubmissionVerificationIdIndexImport } from './routes/_backoffice/edit-penyuluh/submission/$verificationId/index'
import { Route as GuestGuestExtensionsInstitutionsProvinceIdImport } from './routes/_guest/guest/extensions-institutions/province/$id'
import { Route as GuestGuestExtensionsInstitutionsPosluhdesIdImport } from './routes/_guest/guest/extensions-institutions/posluhdes/$id'
import { Route as GuestGuestExtensionsInstitutionsCityIdImport } from './routes/_guest/guest/extensions-institutions/city/$id'
import { Route as GuestGuestExtensionsInstitutionsBppIdImport } from './routes/_guest/guest/extensions-institutions/bpp/$id'
import { Route as BackofficeUserProvinsiAdminIdEditImport } from './routes/_backoffice/user/provinsi/$adminId/edit'
import { Route as BackofficeUserKabupatenAdminIdEditImport } from './routes/_backoffice/user/kabupaten/$adminId/edit'
import { Route as BackofficeUserBppAdminIdEditImport } from './routes/_backoffice/user/bpp/$adminId/edit'
import { Route as BackofficeUserAdminAdminIdEditImport } from './routes/_backoffice/user/admin/$adminId/edit'
import { Route as BackofficeKlbPetaniPoktanPoktanIdEditImport } from './routes/_backoffice/klb-petani/poktan/$poktanId/edit'
import { Route as BackofficeKlbPetaniPetaniPetaniIdEditImport } from './routes/_backoffice/klb-petani/petani/$petaniId/edit'
import { Route as BackofficeKlbPetaniGapoktanGapoktanIdEditImport } from './routes/_backoffice/klb-petani/gapoktan/$gapoktanId/edit'
import { Route as BackofficeKlbPenyuluhKotakabKotakabIdEditImport } from './routes/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit'
import { Route as BackofficeKlbPenyuluhKecamatanBppIdEditImport } from './routes/_backoffice/klb-penyuluh/kecamatan/$bppId/edit'
import { Route as BackofficeKlbPenyuluhDesaPenyuluhIdEditImport } from './routes/_backoffice/klb-penyuluh/desa/$penyuluhId/edit'
import { Route as BackofficeKtgPenyuluhSwastaSwastaIdEditIndexImport } from './routes/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/index'
import { Route as BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexImport } from './routes/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/index'
import { Route as BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexImport } from './routes/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/index'
import { Route as BackofficeKtgPenyuluhApbnApbnIdEditIndexImport } from './routes/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/index'
import { Route as BackofficeKtgPenyuluhApbdApbdIdEditIndexImport } from './routes/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/index'
import { Route as BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexImport } from './routes/_backoffice/klb-petani/poktan/submission/$verificationId/index'
import { Route as BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexImport } from './routes/_backoffice/klb-petani/petani/submission/$verificationId/index'
import { Route as BackofficeKlbPetaniKepSubmissionVerificationIdIndexImport } from './routes/_backoffice/klb-petani/kep/submission/$verificationId/index'
import { Route as BackofficeKlbPetaniKepKepIdEditIndexImport } from './routes/_backoffice/klb-petani/kep/$kepId/edit/index'
import { Route as BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexImport } from './routes/_backoffice/klb-petani/gapoktan/submission/$verificationId/index'
import { Route as BackofficeKlbPenyuluhPusatPusatIdEditIndexImport } from './routes/_backoffice/klb-penyuluh/pusat/$pusatId/edit/index'
import { Route as BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexImport } from './routes/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/index'
import { Route as BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexImport } from './routes/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/index'
import { Route as BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexImport } from './routes/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/index'
import { Route as BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexImport } from './routes/_backoffice/klb-petani/petani/$petaniId/lahan/submission/index'
import { Route as BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditImport } from './routes/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
import { Route as BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexImport } from './routes/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/index'
import { Route as BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexImport } from './routes/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/index'

// Create/Update Routes

const ReportRoute = ReportImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => rootRoute,
} as any)

const GuestRoute = GuestImport.update({
  id: '/_guest',
  getParentRoute: () => rootRoute,
} as any)

const BackofficeRoute = BackofficeImport.update({
  id: '/_backoffice',
  getParentRoute: () => rootRoute,
} as any)

const R403Route = R403Import.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSignInRoute = AuthSignInImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const ReportPemetaanWilkerIndexRoute = ReportPemetaanWilkerIndexImport.update({
  id: '/pemetaan-wilker/',
  path: '/pemetaan-wilker/',
  getParentRoute: () => ReportRoute,
} as any)

const GuestGuestIndexRoute = GuestGuestIndexImport.update({
  id: '/guest/',
  path: '/guest/',
  getParentRoute: () => GuestRoute,
} as any)

const BackofficeVerificationWilkerPenyuluhIndexRoute =
  BackofficeVerificationWilkerPenyuluhIndexImport.update({
    id: '/verification-wilker-penyuluh/',
    path: '/verification-wilker-penyuluh/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeVerificationDataIndexRoute =
  BackofficeVerificationDataIndexImport.update({
    id: '/verification-data/',
    path: '/verification-data/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserIndexRoute = BackofficeUserIndexImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeProfileIndexRoute = BackofficeProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeKlbPetaniIndexRoute = BackofficeKlbPetaniIndexImport.update({
  id: '/klb-petani/',
  path: '/klb-petani/',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeEditPenyuluhIndexRoute =
  BackofficeEditPenyuluhIndexImport.update({
    id: '/edit-penyuluh/',
    path: '/edit-penyuluh/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeDashboardIndexRoute = BackofficeDashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeAboutIndexRoute = BackofficeAboutIndexImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => BackofficeRoute,
} as any)

const OauthSimluhtanCallbackRoute = OauthSimluhtanCallbackImport.update({
  id: '/oauth/simluhtan/callback',
  path: '/oauth/simluhtan/callback',
  getParentRoute: () => rootRoute,
} as any)

const GuestGuestRecapShapeKepRoute = GuestGuestRecapShapeKepImport.update({
  id: '/guest/recap-shape-kep',
  path: '/guest/recap-shape-kep',
  getParentRoute: () => GuestRoute,
} as any)

const GuestGuestRecapPoktanRoute = GuestGuestRecapPoktanImport.update({
  id: '/guest/recap-poktan',
  path: '/guest/recap-poktan',
  getParentRoute: () => GuestRoute,
} as any)

const GuestGuestRecapFarmerInstitutionsRoute =
  GuestGuestRecapFarmerInstitutionsImport.update({
    id: '/guest/recap-farmer-institutions',
    path: '/guest/recap-farmer-institutions',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestRecapExtentionsWorkerRoute =
  GuestGuestRecapExtentionsWorkerImport.update({
    id: '/guest/recap-extentions-worker',
    path: '/guest/recap-extentions-worker',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestRecapExtensionsInstitutionsRoute =
  GuestGuestRecapExtensionsInstitutionsImport.update({
    id: '/guest/recap-extensions-institutions',
    path: '/guest/recap-extensions-institutions',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestRecapClassificationsBppRoute =
  GuestGuestRecapClassificationsBppImport.update({
    id: '/guest/recap-classifications-bpp',
    path: '/guest/recap-classifications-bpp',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestRecapClassPoktanRoute = GuestGuestRecapClassPoktanImport.update(
  {
    id: '/guest/recap-class-poktan',
    path: '/guest/recap-class-poktan',
    getParentRoute: () => GuestRoute,
  } as any,
)

const GuestGuestListPoktanMemberRoute = GuestGuestListPoktanMemberImport.update(
  {
    id: '/guest/list-poktan-member',
    path: '/guest/list-poktan-member',
    getParentRoute: () => GuestRoute,
  } as any,
)

const GuestGuestListPoktanRoute = GuestGuestListPoktanImport.update({
  id: '/guest/list-poktan',
  path: '/guest/list-poktan',
  getParentRoute: () => GuestRoute,
} as any)

const GuestGuestListKepRoute = GuestGuestListKepImport.update({
  id: '/guest/list-kep',
  path: '/guest/list-kep',
  getParentRoute: () => GuestRoute,
} as any)

const GuestGuestListGapoktanRoute = GuestGuestListGapoktanImport.update({
  id: '/guest/list-gapoktan',
  path: '/guest/list-gapoktan',
  getParentRoute: () => GuestRoute,
} as any)

const GuestGuestKtgWorkerListRoute = GuestGuestKtgWorkerListImport.update({
  id: '/guest/ktg-worker-list',
  path: '/guest/ktg-worker-list',
  getParentRoute: () => GuestRoute,
} as any)

const ReportPemetaanWilkerProvinsiIdIndexRoute =
  ReportPemetaanWilkerProvinsiIdIndexImport.update({
    id: '/pemetaan-wilker/$provinsiId/',
    path: '/pemetaan-wilker/$provinsiId/',
    getParentRoute: () => ReportRoute,
  } as any)

const GuestGuestExtensionsInstitutionsIndexRoute =
  GuestGuestExtensionsInstitutionsIndexImport.update({
    id: '/guest/extensions-institutions/',
    path: '/guest/extensions-institutions/',
    getParentRoute: () => GuestRoute,
  } as any)

const BackofficeVerificationDataVerificationIdIndexRoute =
  BackofficeVerificationDataVerificationIdIndexImport.update({
    id: '/verification-data/$verificationId/',
    path: '/verification-data/$verificationId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserProvinsiIndexRoute =
  BackofficeUserProvinsiIndexImport.update({
    id: '/user/provinsi/',
    path: '/user/provinsi/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserKabupatenIndexRoute =
  BackofficeUserKabupatenIndexImport.update({
    id: '/user/kabupaten/',
    path: '/user/kabupaten/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserBppIndexRoute = BackofficeUserBppIndexImport.update({
  id: '/user/bpp/',
  path: '/user/bpp/',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeUserAdminIndexRoute = BackofficeUserAdminIndexImport.update({
  id: '/user/admin/',
  path: '/user/admin/',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeKtgPenyuluhSwastaIndexRoute =
  BackofficeKtgPenyuluhSwastaIndexImport.update({
    id: '/ktg-penyuluh/swasta/',
    path: '/ktg-penyuluh/swasta/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhSwadayaIndexRoute =
  BackofficeKtgPenyuluhSwadayaIndexImport.update({
    id: '/ktg-penyuluh/swadaya/',
    path: '/ktg-penyuluh/swadaya/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhPnsPppkIndexRoute =
  BackofficeKtgPenyuluhPnsPppkIndexImport.update({
    id: '/ktg-penyuluh/pns-pppk/',
    path: '/ktg-penyuluh/pns-pppk/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhPindahDomisiliIndexRoute =
  BackofficeKtgPenyuluhPindahDomisiliIndexImport.update({
    id: '/ktg-penyuluh/pindah-domisili/',
    path: '/ktg-penyuluh/pindah-domisili/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbnIndexRoute =
  BackofficeKtgPenyuluhApbnIndexImport.update({
    id: '/ktg-penyuluh/apbn/',
    path: '/ktg-penyuluh/apbn/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbdIndexRoute =
  BackofficeKtgPenyuluhApbdIndexImport.update({
    id: '/ktg-penyuluh/apbd/',
    path: '/ktg-penyuluh/apbd/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanIndexRoute =
  BackofficeKlbPetaniPoktanIndexImport.update({
    id: '/klb-petani/poktan/',
    path: '/klb-petani/poktan/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniIndexRoute =
  BackofficeKlbPetaniPetaniIndexImport.update({
    id: '/klb-petani/petani/',
    path: '/klb-petani/petani/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniKepIndexRoute =
  BackofficeKlbPetaniKepIndexImport.update({
    id: '/klb-petani/kep/',
    path: '/klb-petani/kep/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniGapoktanIndexRoute =
  BackofficeKlbPetaniGapoktanIndexImport.update({
    id: '/klb-petani/gapoktan/',
    path: '/klb-petani/gapoktan/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniCariPetaniIndexRoute =
  BackofficeKlbPetaniCariPetaniIndexImport.update({
    id: '/klb-petani/cari-petani/',
    path: '/klb-petani/cari-petani/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhPusatIndexRoute =
  BackofficeKlbPenyuluhPusatIndexImport.update({
    id: '/klb-penyuluh/pusat/',
    path: '/klb-penyuluh/pusat/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhProvinsiIndexRoute =
  BackofficeKlbPenyuluhProvinsiIndexImport.update({
    id: '/klb-penyuluh/provinsi/',
    path: '/klb-penyuluh/provinsi/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKotakabIndexRoute =
  BackofficeKlbPenyuluhKotakabIndexImport.update({
    id: '/klb-penyuluh/kotakab/',
    path: '/klb-penyuluh/kotakab/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKecamatanIndexRoute =
  BackofficeKlbPenyuluhKecamatanIndexImport.update({
    id: '/klb-penyuluh/kecamatan/',
    path: '/klb-penyuluh/kecamatan/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhDesaIndexRoute =
  BackofficeKlbPenyuluhDesaIndexImport.update({
    id: '/klb-penyuluh/desa/',
    path: '/klb-penyuluh/desa/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeEditPenyuluhSubmissionIndexRoute =
  BackofficeEditPenyuluhSubmissionIndexImport.update({
    id: '/edit-penyuluh/submission/',
    path: '/edit-penyuluh/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeAboutCreateIndexRoute = BackofficeAboutCreateIndexImport.update(
  {
    id: '/about/create/',
    path: '/about/create/',
    getParentRoute: () => BackofficeRoute,
  } as any,
)

const GuestGuestSearchKtgExtensionsInstitutionsRoute =
  GuestGuestSearchKtgExtensionsInstitutionsImport.update({
    id: '/guest/search/ktg-extensions-institutions',
    path: '/guest/search/ktg-extensions-institutions',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestSearchKlbFarmersRoute = GuestGuestSearchKlbFarmersImport.update(
  {
    id: '/guest/search/klb-farmers',
    path: '/guest/search/klb-farmers',
    getParentRoute: () => GuestRoute,
  } as any,
)

const GuestGuestSearchFarmerPoktanMembersRoute =
  GuestGuestSearchFarmerPoktanMembersImport.update({
    id: '/guest/search/farmer-poktan-members',
    path: '/guest/search/farmer-poktan-members',
    getParentRoute: () => GuestRoute,
  } as any)

const BackofficeUserProvinsiCreateRoute =
  BackofficeUserProvinsiCreateImport.update({
    id: '/user/provinsi/create',
    path: '/user/provinsi/create',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserKabupatenCreateRoute =
  BackofficeUserKabupatenCreateImport.update({
    id: '/user/kabupaten/create',
    path: '/user/kabupaten/create',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserBppCreateRoute = BackofficeUserBppCreateImport.update({
  id: '/user/bpp/create',
  path: '/user/bpp/create',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeUserAdminCreateRoute = BackofficeUserAdminCreateImport.update({
  id: '/user/admin/create',
  path: '/user/admin/create',
  getParentRoute: () => BackofficeRoute,
} as any)

const BackofficeKlbPenyuluhKotakabCreateRoute =
  BackofficeKlbPenyuluhKotakabCreateImport.update({
    id: '/klb-penyuluh/kotakab/create',
    path: '/klb-penyuluh/kotakab/create',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKecamatanCreateRoute =
  BackofficeKlbPenyuluhKecamatanCreateImport.update({
    id: '/klb-penyuluh/kecamatan/create',
    path: '/klb-penyuluh/kecamatan/create',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhDesaCreateRoute =
  BackofficeKlbPenyuluhDesaCreateImport.update({
    id: '/klb-penyuluh/desa/create',
    path: '/klb-penyuluh/desa/create',
    getParentRoute: () => BackofficeRoute,
  } as any)

const ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute =
  ReportPemetaanWilkerProvinsiIdKotaIdIndexImport.update({
    id: '/pemetaan-wilker/$provinsiId/$kotaId/',
    path: '/pemetaan-wilker/$provinsiId/$kotaId/',
    getParentRoute: () => ReportRoute,
  } as any)

const BackofficeKtgPenyuluhSwastaCreateIndexRoute =
  BackofficeKtgPenyuluhSwastaCreateIndexImport.update({
    id: '/ktg-penyuluh/swasta/create/',
    path: '/ktg-penyuluh/swasta/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute =
  BackofficeKtgPenyuluhSwastaSwastaIdIndexImport.update({
    id: '/ktg-penyuluh/swasta/$swastaId/',
    path: '/ktg-penyuluh/swasta/$swastaId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhSwadayaCreateIndexRoute =
  BackofficeKtgPenyuluhSwadayaCreateIndexImport.update({
    id: '/ktg-penyuluh/swadaya/create/',
    path: '/ktg-penyuluh/swadaya/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute =
  BackofficeKtgPenyuluhSwadayaSwadayaIdIndexImport.update({
    id: '/ktg-penyuluh/swadaya/$swadayaId/',
    path: '/ktg-penyuluh/swadaya/$swadayaId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhPnsPppkCreateIndexRoute =
  BackofficeKtgPenyuluhPnsPppkCreateIndexImport.update({
    id: '/ktg-penyuluh/pns-pppk/create/',
    path: '/ktg-penyuluh/pns-pppk/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute =
  BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexImport.update({
    id: '/ktg-penyuluh/pns-pppk/$pnsPppkId/',
    path: '/ktg-penyuluh/pns-pppk/$pnsPppkId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbnCreateIndexRoute =
  BackofficeKtgPenyuluhApbnCreateIndexImport.update({
    id: '/ktg-penyuluh/apbn/create/',
    path: '/ktg-penyuluh/apbn/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbnApbnIdIndexRoute =
  BackofficeKtgPenyuluhApbnApbnIdIndexImport.update({
    id: '/ktg-penyuluh/apbn/$apbnId/',
    path: '/ktg-penyuluh/apbn/$apbnId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbdCreateIndexRoute =
  BackofficeKtgPenyuluhApbdCreateIndexImport.update({
    id: '/ktg-penyuluh/apbd/create/',
    path: '/ktg-penyuluh/apbd/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbdApbdIdIndexRoute =
  BackofficeKtgPenyuluhApbdApbdIdIndexImport.update({
    id: '/ktg-penyuluh/apbd/$apbdId/',
    path: '/ktg-penyuluh/apbd/$apbdId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanSubmissionIndexRoute =
  BackofficeKlbPetaniPoktanSubmissionIndexImport.update({
    id: '/klb-petani/poktan/submission/',
    path: '/klb-petani/poktan/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanCreateIndexRoute =
  BackofficeKlbPetaniPoktanCreateIndexImport.update({
    id: '/klb-petani/poktan/create/',
    path: '/klb-petani/poktan/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanPoktanIdIndexRoute =
  BackofficeKlbPetaniPoktanPoktanIdIndexImport.update({
    id: '/klb-petani/poktan/$poktanId/',
    path: '/klb-petani/poktan/$poktanId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniSubmissionIndexRoute =
  BackofficeKlbPetaniPetaniSubmissionIndexImport.update({
    id: '/klb-petani/petani/submission/',
    path: '/klb-petani/petani/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniCreateIndexRoute =
  BackofficeKlbPetaniPetaniCreateIndexImport.update({
    id: '/klb-petani/petani/create/',
    path: '/klb-petani/petani/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniPetaniIdIndexRoute =
  BackofficeKlbPetaniPetaniPetaniIdIndexImport.update({
    id: '/klb-petani/petani/$petaniId/',
    path: '/klb-petani/petani/$petaniId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniKepSubmissionIndexRoute =
  BackofficeKlbPetaniKepSubmissionIndexImport.update({
    id: '/klb-petani/kep/submission/',
    path: '/klb-petani/kep/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniKepCreateIndexRoute =
  BackofficeKlbPetaniKepCreateIndexImport.update({
    id: '/klb-petani/kep/create/',
    path: '/klb-petani/kep/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniKepKepIdIndexRoute =
  BackofficeKlbPetaniKepKepIdIndexImport.update({
    id: '/klb-petani/kep/$kepId/',
    path: '/klb-petani/kep/$kepId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniGapoktanSubmissionIndexRoute =
  BackofficeKlbPetaniGapoktanSubmissionIndexImport.update({
    id: '/klb-petani/gapoktan/submission/',
    path: '/klb-petani/gapoktan/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniGapoktanCreateIndexRoute =
  BackofficeKlbPetaniGapoktanCreateIndexImport.update({
    id: '/klb-petani/gapoktan/create/',
    path: '/klb-petani/gapoktan/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute =
  BackofficeKlbPetaniGapoktanGapoktanIdIndexImport.update({
    id: '/klb-petani/gapoktan/$gapoktanId/',
    path: '/klb-petani/gapoktan/$gapoktanId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute =
  BackofficeKlbPetaniCariPetaniCariPetaniIdIndexImport.update({
    id: '/klb-petani/cari-petani/$cariPetaniId/',
    path: '/klb-petani/cari-petani/$cariPetaniId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhPusatCreateIndexRoute =
  BackofficeKlbPenyuluhPusatCreateIndexImport.update({
    id: '/klb-penyuluh/pusat/create/',
    path: '/klb-penyuluh/pusat/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhPusatPusatIdIndexRoute =
  BackofficeKlbPenyuluhPusatPusatIdIndexImport.update({
    id: '/klb-penyuluh/pusat/$pusatId/',
    path: '/klb-penyuluh/pusat/$pusatId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhProvinsiCreateIndexRoute =
  BackofficeKlbPenyuluhProvinsiCreateIndexImport.update({
    id: '/klb-penyuluh/provinsi/create/',
    path: '/klb-penyuluh/provinsi/create/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute =
  BackofficeKlbPenyuluhProvinsiProvinsiIdIndexImport.update({
    id: '/klb-penyuluh/provinsi/$provinsiId/',
    path: '/klb-penyuluh/provinsi/$provinsiId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute =
  BackofficeKlbPenyuluhKotakabKotakabIdIndexImport.update({
    id: '/klb-penyuluh/kotakab/$kotakabId/',
    path: '/klb-penyuluh/kotakab/$kotakabId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKecamatanBppIdIndexRoute =
  BackofficeKlbPenyuluhKecamatanBppIdIndexImport.update({
    id: '/klb-penyuluh/kecamatan/$bppId/',
    path: '/klb-penyuluh/kecamatan/$bppId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute =
  BackofficeEditPenyuluhSubmissionVerificationIdIndexImport.update({
    id: '/edit-penyuluh/submission/$verificationId/',
    path: '/edit-penyuluh/submission/$verificationId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const GuestGuestExtensionsInstitutionsProvinceIdRoute =
  GuestGuestExtensionsInstitutionsProvinceIdImport.update({
    id: '/guest/extensions-institutions/province/$id',
    path: '/guest/extensions-institutions/province/$id',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestExtensionsInstitutionsPosluhdesIdRoute =
  GuestGuestExtensionsInstitutionsPosluhdesIdImport.update({
    id: '/guest/extensions-institutions/posluhdes/$id',
    path: '/guest/extensions-institutions/posluhdes/$id',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestExtensionsInstitutionsCityIdRoute =
  GuestGuestExtensionsInstitutionsCityIdImport.update({
    id: '/guest/extensions-institutions/city/$id',
    path: '/guest/extensions-institutions/city/$id',
    getParentRoute: () => GuestRoute,
  } as any)

const GuestGuestExtensionsInstitutionsBppIdRoute =
  GuestGuestExtensionsInstitutionsBppIdImport.update({
    id: '/guest/extensions-institutions/bpp/$id',
    path: '/guest/extensions-institutions/bpp/$id',
    getParentRoute: () => GuestRoute,
  } as any)

const BackofficeUserProvinsiAdminIdEditRoute =
  BackofficeUserProvinsiAdminIdEditImport.update({
    id: '/user/provinsi/$adminId/edit',
    path: '/user/provinsi/$adminId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserKabupatenAdminIdEditRoute =
  BackofficeUserKabupatenAdminIdEditImport.update({
    id: '/user/kabupaten/$adminId/edit',
    path: '/user/kabupaten/$adminId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserBppAdminIdEditRoute =
  BackofficeUserBppAdminIdEditImport.update({
    id: '/user/bpp/$adminId/edit',
    path: '/user/bpp/$adminId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeUserAdminAdminIdEditRoute =
  BackofficeUserAdminAdminIdEditImport.update({
    id: '/user/admin/$adminId/edit',
    path: '/user/admin/$adminId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanPoktanIdEditRoute =
  BackofficeKlbPetaniPoktanPoktanIdEditImport.update({
    id: '/klb-petani/poktan/$poktanId/edit',
    path: '/klb-petani/poktan/$poktanId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniPetaniIdEditRoute =
  BackofficeKlbPetaniPetaniPetaniIdEditImport.update({
    id: '/klb-petani/petani/$petaniId/edit',
    path: '/klb-petani/petani/$petaniId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniGapoktanGapoktanIdEditRoute =
  BackofficeKlbPetaniGapoktanGapoktanIdEditImport.update({
    id: '/klb-petani/gapoktan/$gapoktanId/edit',
    path: '/klb-petani/gapoktan/$gapoktanId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKotakabKotakabIdEditRoute =
  BackofficeKlbPenyuluhKotakabKotakabIdEditImport.update({
    id: '/klb-penyuluh/kotakab/$kotakabId/edit',
    path: '/klb-penyuluh/kotakab/$kotakabId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhKecamatanBppIdEditRoute =
  BackofficeKlbPenyuluhKecamatanBppIdEditImport.update({
    id: '/klb-penyuluh/kecamatan/$bppId/edit',
    path: '/klb-penyuluh/kecamatan/$bppId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute =
  BackofficeKlbPenyuluhDesaPenyuluhIdEditImport.update({
    id: '/klb-penyuluh/desa/$penyuluhId/edit',
    path: '/klb-penyuluh/desa/$penyuluhId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute =
  BackofficeKtgPenyuluhSwastaSwastaIdEditIndexImport.update({
    id: '/ktg-penyuluh/swasta/$swastaId/edit/',
    path: '/ktg-penyuluh/swasta/$swastaId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute =
  BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexImport.update({
    id: '/ktg-penyuluh/swadaya/$swadayaId/edit/',
    path: '/ktg-penyuluh/swadaya/$swadayaId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute =
  BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexImport.update({
    id: '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/',
    path: '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute =
  BackofficeKtgPenyuluhApbnApbnIdEditIndexImport.update({
    id: '/ktg-penyuluh/apbn/$apbnId/edit/',
    path: '/ktg-penyuluh/apbn/$apbnId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute =
  BackofficeKtgPenyuluhApbdApbdIdEditIndexImport.update({
    id: '/ktg-penyuluh/apbd/$apbdId/edit/',
    path: '/ktg-penyuluh/apbd/$apbdId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute =
  BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexImport.update({
    id: '/klb-petani/poktan/submission/$verificationId/',
    path: '/klb-petani/poktan/submission/$verificationId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute =
  BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexImport.update({
    id: '/klb-petani/petani/submission/$verificationId/',
    path: '/klb-petani/petani/submission/$verificationId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute =
  BackofficeKlbPetaniKepSubmissionVerificationIdIndexImport.update({
    id: '/klb-petani/kep/submission/$verificationId/',
    path: '/klb-petani/kep/submission/$verificationId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniKepKepIdEditIndexRoute =
  BackofficeKlbPetaniKepKepIdEditIndexImport.update({
    id: '/klb-petani/kep/$kepId/edit/',
    path: '/klb-petani/kep/$kepId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute =
  BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexImport.update({
    id: '/klb-petani/gapoktan/submission/$verificationId/',
    path: '/klb-petani/gapoktan/submission/$verificationId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute =
  BackofficeKlbPenyuluhPusatPusatIdEditIndexImport.update({
    id: '/klb-penyuluh/pusat/$pusatId/edit/',
    path: '/klb-penyuluh/pusat/$pusatId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute =
  BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexImport.update({
    id: '/klb-penyuluh/provinsi/$provinsiId/edit/',
    path: '/klb-penyuluh/provinsi/$provinsiId/edit/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute =
  BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexImport.update({
    id: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/',
    path: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute =
  BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexImport.update({
    id: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/',
    path: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute =
  BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexImport.update({
    id: '/klb-petani/petani/$petaniId/lahan/submission/',
    path: '/klb-petani/petani/$petaniId/lahan/submission/',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute =
  BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditImport.update({
    id: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit',
    path: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit',
    getParentRoute: () => BackofficeRoute,
  } as any)

const BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute =
  BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexImport.update(
    {
      id: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/',
      path: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/',
      getParentRoute: () => BackofficeRoute,
    } as any,
  )

const BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute =
  BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexImport.update(
    {
      id: '/klb-petani/petani/$petaniId/lahan/submission/$verificationId/',
      path: '/klb-petani/petani/$petaniId/lahan/submission/$verificationId/',
      getParentRoute: () => BackofficeRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403Import
      parentRoute: typeof rootRoute
    }
    '/_backoffice': {
      id: '/_backoffice'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BackofficeImport
      parentRoute: typeof rootRoute
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof GuestImport
      parentRoute: typeof rootRoute
    }
    '/report': {
      id: '/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof ReportImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInImport
      parentRoute: typeof rootRoute
    }
    '/_guest/guest/ktg-worker-list': {
      id: '/_guest/guest/ktg-worker-list'
      path: '/guest/ktg-worker-list'
      fullPath: '/guest/ktg-worker-list'
      preLoaderRoute: typeof GuestGuestKtgWorkerListImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/list-gapoktan': {
      id: '/_guest/guest/list-gapoktan'
      path: '/guest/list-gapoktan'
      fullPath: '/guest/list-gapoktan'
      preLoaderRoute: typeof GuestGuestListGapoktanImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/list-kep': {
      id: '/_guest/guest/list-kep'
      path: '/guest/list-kep'
      fullPath: '/guest/list-kep'
      preLoaderRoute: typeof GuestGuestListKepImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/list-poktan': {
      id: '/_guest/guest/list-poktan'
      path: '/guest/list-poktan'
      fullPath: '/guest/list-poktan'
      preLoaderRoute: typeof GuestGuestListPoktanImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/list-poktan-member': {
      id: '/_guest/guest/list-poktan-member'
      path: '/guest/list-poktan-member'
      fullPath: '/guest/list-poktan-member'
      preLoaderRoute: typeof GuestGuestListPoktanMemberImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-class-poktan': {
      id: '/_guest/guest/recap-class-poktan'
      path: '/guest/recap-class-poktan'
      fullPath: '/guest/recap-class-poktan'
      preLoaderRoute: typeof GuestGuestRecapClassPoktanImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-classifications-bpp': {
      id: '/_guest/guest/recap-classifications-bpp'
      path: '/guest/recap-classifications-bpp'
      fullPath: '/guest/recap-classifications-bpp'
      preLoaderRoute: typeof GuestGuestRecapClassificationsBppImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-extensions-institutions': {
      id: '/_guest/guest/recap-extensions-institutions'
      path: '/guest/recap-extensions-institutions'
      fullPath: '/guest/recap-extensions-institutions'
      preLoaderRoute: typeof GuestGuestRecapExtensionsInstitutionsImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-extentions-worker': {
      id: '/_guest/guest/recap-extentions-worker'
      path: '/guest/recap-extentions-worker'
      fullPath: '/guest/recap-extentions-worker'
      preLoaderRoute: typeof GuestGuestRecapExtentionsWorkerImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-farmer-institutions': {
      id: '/_guest/guest/recap-farmer-institutions'
      path: '/guest/recap-farmer-institutions'
      fullPath: '/guest/recap-farmer-institutions'
      preLoaderRoute: typeof GuestGuestRecapFarmerInstitutionsImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-poktan': {
      id: '/_guest/guest/recap-poktan'
      path: '/guest/recap-poktan'
      fullPath: '/guest/recap-poktan'
      preLoaderRoute: typeof GuestGuestRecapPoktanImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/recap-shape-kep': {
      id: '/_guest/guest/recap-shape-kep'
      path: '/guest/recap-shape-kep'
      fullPath: '/guest/recap-shape-kep'
      preLoaderRoute: typeof GuestGuestRecapShapeKepImport
      parentRoute: typeof GuestImport
    }
    '/oauth/simluhtan/callback': {
      id: '/oauth/simluhtan/callback'
      path: '/oauth/simluhtan/callback'
      fullPath: '/oauth/simluhtan/callback'
      preLoaderRoute: typeof OauthSimluhtanCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_backoffice/about/': {
      id: '/_backoffice/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof BackofficeAboutIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/dashboard/': {
      id: '/_backoffice/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof BackofficeDashboardIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/edit-penyuluh/': {
      id: '/_backoffice/edit-penyuluh/'
      path: '/edit-penyuluh'
      fullPath: '/edit-penyuluh'
      preLoaderRoute: typeof BackofficeEditPenyuluhIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/': {
      id: '/_backoffice/klb-petani/'
      path: '/klb-petani'
      fullPath: '/klb-petani'
      preLoaderRoute: typeof BackofficeKlbPetaniIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/profile/': {
      id: '/_backoffice/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof BackofficeProfileIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/': {
      id: '/_backoffice/user/'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof BackofficeUserIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/verification-data/': {
      id: '/_backoffice/verification-data/'
      path: '/verification-data'
      fullPath: '/verification-data'
      preLoaderRoute: typeof BackofficeVerificationDataIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/verification-wilker-penyuluh/': {
      id: '/_backoffice/verification-wilker-penyuluh/'
      path: '/verification-wilker-penyuluh'
      fullPath: '/verification-wilker-penyuluh'
      preLoaderRoute: typeof BackofficeVerificationWilkerPenyuluhIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_guest/guest/': {
      id: '/_guest/guest/'
      path: '/guest'
      fullPath: '/guest'
      preLoaderRoute: typeof GuestGuestIndexImport
      parentRoute: typeof GuestImport
    }
    '/report/pemetaan-wilker/': {
      id: '/report/pemetaan-wilker/'
      path: '/pemetaan-wilker'
      fullPath: '/report/pemetaan-wilker'
      preLoaderRoute: typeof ReportPemetaanWilkerIndexImport
      parentRoute: typeof ReportImport
    }
    '/_backoffice/klb-penyuluh/desa/create': {
      id: '/_backoffice/klb-penyuluh/desa/create'
      path: '/klb-penyuluh/desa/create'
      fullPath: '/klb-penyuluh/desa/create'
      preLoaderRoute: typeof BackofficeKlbPenyuluhDesaCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kecamatan/create': {
      id: '/_backoffice/klb-penyuluh/kecamatan/create'
      path: '/klb-penyuluh/kecamatan/create'
      fullPath: '/klb-penyuluh/kecamatan/create'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKecamatanCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kotakab/create': {
      id: '/_backoffice/klb-penyuluh/kotakab/create'
      path: '/klb-penyuluh/kotakab/create'
      fullPath: '/klb-penyuluh/kotakab/create'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKotakabCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/admin/create': {
      id: '/_backoffice/user/admin/create'
      path: '/user/admin/create'
      fullPath: '/user/admin/create'
      preLoaderRoute: typeof BackofficeUserAdminCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/bpp/create': {
      id: '/_backoffice/user/bpp/create'
      path: '/user/bpp/create'
      fullPath: '/user/bpp/create'
      preLoaderRoute: typeof BackofficeUserBppCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/kabupaten/create': {
      id: '/_backoffice/user/kabupaten/create'
      path: '/user/kabupaten/create'
      fullPath: '/user/kabupaten/create'
      preLoaderRoute: typeof BackofficeUserKabupatenCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/provinsi/create': {
      id: '/_backoffice/user/provinsi/create'
      path: '/user/provinsi/create'
      fullPath: '/user/provinsi/create'
      preLoaderRoute: typeof BackofficeUserProvinsiCreateImport
      parentRoute: typeof BackofficeImport
    }
    '/_guest/guest/search/farmer-poktan-members': {
      id: '/_guest/guest/search/farmer-poktan-members'
      path: '/guest/search/farmer-poktan-members'
      fullPath: '/guest/search/farmer-poktan-members'
      preLoaderRoute: typeof GuestGuestSearchFarmerPoktanMembersImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/search/klb-farmers': {
      id: '/_guest/guest/search/klb-farmers'
      path: '/guest/search/klb-farmers'
      fullPath: '/guest/search/klb-farmers'
      preLoaderRoute: typeof GuestGuestSearchKlbFarmersImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/search/ktg-extensions-institutions': {
      id: '/_guest/guest/search/ktg-extensions-institutions'
      path: '/guest/search/ktg-extensions-institutions'
      fullPath: '/guest/search/ktg-extensions-institutions'
      preLoaderRoute: typeof GuestGuestSearchKtgExtensionsInstitutionsImport
      parentRoute: typeof GuestImport
    }
    '/_backoffice/about/create/': {
      id: '/_backoffice/about/create/'
      path: '/about/create'
      fullPath: '/about/create'
      preLoaderRoute: typeof BackofficeAboutCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/edit-penyuluh/submission/': {
      id: '/_backoffice/edit-penyuluh/submission/'
      path: '/edit-penyuluh/submission'
      fullPath: '/edit-penyuluh/submission'
      preLoaderRoute: typeof BackofficeEditPenyuluhSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/desa/': {
      id: '/_backoffice/klb-penyuluh/desa/'
      path: '/klb-penyuluh/desa'
      fullPath: '/klb-penyuluh/desa'
      preLoaderRoute: typeof BackofficeKlbPenyuluhDesaIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kecamatan/': {
      id: '/_backoffice/klb-penyuluh/kecamatan/'
      path: '/klb-penyuluh/kecamatan'
      fullPath: '/klb-penyuluh/kecamatan'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKecamatanIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kotakab/': {
      id: '/_backoffice/klb-penyuluh/kotakab/'
      path: '/klb-penyuluh/kotakab'
      fullPath: '/klb-penyuluh/kotakab'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKotakabIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/provinsi/': {
      id: '/_backoffice/klb-penyuluh/provinsi/'
      path: '/klb-penyuluh/provinsi'
      fullPath: '/klb-penyuluh/provinsi'
      preLoaderRoute: typeof BackofficeKlbPenyuluhProvinsiIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/pusat/': {
      id: '/_backoffice/klb-penyuluh/pusat/'
      path: '/klb-penyuluh/pusat'
      fullPath: '/klb-penyuluh/pusat'
      preLoaderRoute: typeof BackofficeKlbPenyuluhPusatIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/cari-petani/': {
      id: '/_backoffice/klb-petani/cari-petani/'
      path: '/klb-petani/cari-petani'
      fullPath: '/klb-petani/cari-petani'
      preLoaderRoute: typeof BackofficeKlbPetaniCariPetaniIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/gapoktan/': {
      id: '/_backoffice/klb-petani/gapoktan/'
      path: '/klb-petani/gapoktan'
      fullPath: '/klb-petani/gapoktan'
      preLoaderRoute: typeof BackofficeKlbPetaniGapoktanIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/kep/': {
      id: '/_backoffice/klb-petani/kep/'
      path: '/klb-petani/kep'
      fullPath: '/klb-petani/kep'
      preLoaderRoute: typeof BackofficeKlbPetaniKepIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/': {
      id: '/_backoffice/klb-petani/petani/'
      path: '/klb-petani/petani'
      fullPath: '/klb-petani/petani'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/': {
      id: '/_backoffice/klb-petani/poktan/'
      path: '/klb-petani/poktan'
      fullPath: '/klb-petani/poktan'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbd/': {
      id: '/_backoffice/ktg-penyuluh/apbd/'
      path: '/ktg-penyuluh/apbd'
      fullPath: '/ktg-penyuluh/apbd'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbn/': {
      id: '/_backoffice/ktg-penyuluh/apbn/'
      path: '/ktg-penyuluh/apbn'
      fullPath: '/ktg-penyuluh/apbn'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbnIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/pindah-domisili/': {
      id: '/_backoffice/ktg-penyuluh/pindah-domisili/'
      path: '/ktg-penyuluh/pindah-domisili'
      fullPath: '/ktg-penyuluh/pindah-domisili'
      preLoaderRoute: typeof BackofficeKtgPenyuluhPindahDomisiliIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/pns-pppk/': {
      id: '/_backoffice/ktg-penyuluh/pns-pppk/'
      path: '/ktg-penyuluh/pns-pppk'
      fullPath: '/ktg-penyuluh/pns-pppk'
      preLoaderRoute: typeof BackofficeKtgPenyuluhPnsPppkIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swadaya/': {
      id: '/_backoffice/ktg-penyuluh/swadaya/'
      path: '/ktg-penyuluh/swadaya'
      fullPath: '/ktg-penyuluh/swadaya'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwadayaIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swasta/': {
      id: '/_backoffice/ktg-penyuluh/swasta/'
      path: '/ktg-penyuluh/swasta'
      fullPath: '/ktg-penyuluh/swasta'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwastaIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/admin/': {
      id: '/_backoffice/user/admin/'
      path: '/user/admin'
      fullPath: '/user/admin'
      preLoaderRoute: typeof BackofficeUserAdminIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/bpp/': {
      id: '/_backoffice/user/bpp/'
      path: '/user/bpp'
      fullPath: '/user/bpp'
      preLoaderRoute: typeof BackofficeUserBppIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/kabupaten/': {
      id: '/_backoffice/user/kabupaten/'
      path: '/user/kabupaten'
      fullPath: '/user/kabupaten'
      preLoaderRoute: typeof BackofficeUserKabupatenIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/provinsi/': {
      id: '/_backoffice/user/provinsi/'
      path: '/user/provinsi'
      fullPath: '/user/provinsi'
      preLoaderRoute: typeof BackofficeUserProvinsiIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/verification-data/$verificationId/': {
      id: '/_backoffice/verification-data/$verificationId/'
      path: '/verification-data/$verificationId'
      fullPath: '/verification-data/$verificationId'
      preLoaderRoute: typeof BackofficeVerificationDataVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_guest/guest/extensions-institutions/': {
      id: '/_guest/guest/extensions-institutions/'
      path: '/guest/extensions-institutions'
      fullPath: '/guest/extensions-institutions'
      preLoaderRoute: typeof GuestGuestExtensionsInstitutionsIndexImport
      parentRoute: typeof GuestImport
    }
    '/report/pemetaan-wilker/$provinsiId/': {
      id: '/report/pemetaan-wilker/$provinsiId/'
      path: '/pemetaan-wilker/$provinsiId'
      fullPath: '/report/pemetaan-wilker/$provinsiId'
      preLoaderRoute: typeof ReportPemetaanWilkerProvinsiIdIndexImport
      parentRoute: typeof ReportImport
    }
    '/_backoffice/klb-penyuluh/desa/$penyuluhId/edit': {
      id: '/_backoffice/klb-penyuluh/desa/$penyuluhId/edit'
      path: '/klb-penyuluh/desa/$penyuluhId/edit'
      fullPath: '/klb-penyuluh/desa/$penyuluhId/edit'
      preLoaderRoute: typeof BackofficeKlbPenyuluhDesaPenyuluhIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kecamatan/$bppId/edit': {
      id: '/_backoffice/klb-penyuluh/kecamatan/$bppId/edit'
      path: '/klb-penyuluh/kecamatan/$bppId/edit'
      fullPath: '/klb-penyuluh/kecamatan/$bppId/edit'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKecamatanBppIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit': {
      id: '/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit'
      path: '/klb-penyuluh/kotakab/$kotakabId/edit'
      fullPath: '/klb-penyuluh/kotakab/$kotakabId/edit'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKotakabKotakabIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/gapoktan/$gapoktanId/edit': {
      id: '/_backoffice/klb-petani/gapoktan/$gapoktanId/edit'
      path: '/klb-petani/gapoktan/$gapoktanId/edit'
      fullPath: '/klb-petani/gapoktan/$gapoktanId/edit'
      preLoaderRoute: typeof BackofficeKlbPetaniGapoktanGapoktanIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/$petaniId/edit': {
      id: '/_backoffice/klb-petani/petani/$petaniId/edit'
      path: '/klb-petani/petani/$petaniId/edit'
      fullPath: '/klb-petani/petani/$petaniId/edit'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniPetaniIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/$poktanId/edit': {
      id: '/_backoffice/klb-petani/poktan/$poktanId/edit'
      path: '/klb-petani/poktan/$poktanId/edit'
      fullPath: '/klb-petani/poktan/$poktanId/edit'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanPoktanIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/admin/$adminId/edit': {
      id: '/_backoffice/user/admin/$adminId/edit'
      path: '/user/admin/$adminId/edit'
      fullPath: '/user/admin/$adminId/edit'
      preLoaderRoute: typeof BackofficeUserAdminAdminIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/bpp/$adminId/edit': {
      id: '/_backoffice/user/bpp/$adminId/edit'
      path: '/user/bpp/$adminId/edit'
      fullPath: '/user/bpp/$adminId/edit'
      preLoaderRoute: typeof BackofficeUserBppAdminIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/kabupaten/$adminId/edit': {
      id: '/_backoffice/user/kabupaten/$adminId/edit'
      path: '/user/kabupaten/$adminId/edit'
      fullPath: '/user/kabupaten/$adminId/edit'
      preLoaderRoute: typeof BackofficeUserKabupatenAdminIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/user/provinsi/$adminId/edit': {
      id: '/_backoffice/user/provinsi/$adminId/edit'
      path: '/user/provinsi/$adminId/edit'
      fullPath: '/user/provinsi/$adminId/edit'
      preLoaderRoute: typeof BackofficeUserProvinsiAdminIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_guest/guest/extensions-institutions/bpp/$id': {
      id: '/_guest/guest/extensions-institutions/bpp/$id'
      path: '/guest/extensions-institutions/bpp/$id'
      fullPath: '/guest/extensions-institutions/bpp/$id'
      preLoaderRoute: typeof GuestGuestExtensionsInstitutionsBppIdImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/extensions-institutions/city/$id': {
      id: '/_guest/guest/extensions-institutions/city/$id'
      path: '/guest/extensions-institutions/city/$id'
      fullPath: '/guest/extensions-institutions/city/$id'
      preLoaderRoute: typeof GuestGuestExtensionsInstitutionsCityIdImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/extensions-institutions/posluhdes/$id': {
      id: '/_guest/guest/extensions-institutions/posluhdes/$id'
      path: '/guest/extensions-institutions/posluhdes/$id'
      fullPath: '/guest/extensions-institutions/posluhdes/$id'
      preLoaderRoute: typeof GuestGuestExtensionsInstitutionsPosluhdesIdImport
      parentRoute: typeof GuestImport
    }
    '/_guest/guest/extensions-institutions/province/$id': {
      id: '/_guest/guest/extensions-institutions/province/$id'
      path: '/guest/extensions-institutions/province/$id'
      fullPath: '/guest/extensions-institutions/province/$id'
      preLoaderRoute: typeof GuestGuestExtensionsInstitutionsProvinceIdImport
      parentRoute: typeof GuestImport
    }
    '/_backoffice/edit-penyuluh/submission/$verificationId/': {
      id: '/_backoffice/edit-penyuluh/submission/$verificationId/'
      path: '/edit-penyuluh/submission/$verificationId'
      fullPath: '/edit-penyuluh/submission/$verificationId'
      preLoaderRoute: typeof BackofficeEditPenyuluhSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kecamatan/$bppId/': {
      id: '/_backoffice/klb-penyuluh/kecamatan/$bppId/'
      path: '/klb-penyuluh/kecamatan/$bppId'
      fullPath: '/klb-penyuluh/kecamatan/$bppId'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKecamatanBppIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/kotakab/$kotakabId/': {
      id: '/_backoffice/klb-penyuluh/kotakab/$kotakabId/'
      path: '/klb-penyuluh/kotakab/$kotakabId'
      fullPath: '/klb-penyuluh/kotakab/$kotakabId'
      preLoaderRoute: typeof BackofficeKlbPenyuluhKotakabKotakabIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/provinsi/$provinsiId/': {
      id: '/_backoffice/klb-penyuluh/provinsi/$provinsiId/'
      path: '/klb-penyuluh/provinsi/$provinsiId'
      fullPath: '/klb-penyuluh/provinsi/$provinsiId'
      preLoaderRoute: typeof BackofficeKlbPenyuluhProvinsiProvinsiIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/provinsi/create/': {
      id: '/_backoffice/klb-penyuluh/provinsi/create/'
      path: '/klb-penyuluh/provinsi/create'
      fullPath: '/klb-penyuluh/provinsi/create'
      preLoaderRoute: typeof BackofficeKlbPenyuluhProvinsiCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/pusat/$pusatId/': {
      id: '/_backoffice/klb-penyuluh/pusat/$pusatId/'
      path: '/klb-penyuluh/pusat/$pusatId'
      fullPath: '/klb-penyuluh/pusat/$pusatId'
      preLoaderRoute: typeof BackofficeKlbPenyuluhPusatPusatIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/pusat/create/': {
      id: '/_backoffice/klb-penyuluh/pusat/create/'
      path: '/klb-penyuluh/pusat/create'
      fullPath: '/klb-penyuluh/pusat/create'
      preLoaderRoute: typeof BackofficeKlbPenyuluhPusatCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/cari-petani/$cariPetaniId/': {
      id: '/_backoffice/klb-petani/cari-petani/$cariPetaniId/'
      path: '/klb-petani/cari-petani/$cariPetaniId'
      fullPath: '/klb-petani/cari-petani/$cariPetaniId'
      preLoaderRoute: typeof BackofficeKlbPetaniCariPetaniCariPetaniIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/gapoktan/$gapoktanId/': {
      id: '/_backoffice/klb-petani/gapoktan/$gapoktanId/'
      path: '/klb-petani/gapoktan/$gapoktanId'
      fullPath: '/klb-petani/gapoktan/$gapoktanId'
      preLoaderRoute: typeof BackofficeKlbPetaniGapoktanGapoktanIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/gapoktan/create/': {
      id: '/_backoffice/klb-petani/gapoktan/create/'
      path: '/klb-petani/gapoktan/create'
      fullPath: '/klb-petani/gapoktan/create'
      preLoaderRoute: typeof BackofficeKlbPetaniGapoktanCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/gapoktan/submission/': {
      id: '/_backoffice/klb-petani/gapoktan/submission/'
      path: '/klb-petani/gapoktan/submission'
      fullPath: '/klb-petani/gapoktan/submission'
      preLoaderRoute: typeof BackofficeKlbPetaniGapoktanSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/kep/$kepId/': {
      id: '/_backoffice/klb-petani/kep/$kepId/'
      path: '/klb-petani/kep/$kepId'
      fullPath: '/klb-petani/kep/$kepId'
      preLoaderRoute: typeof BackofficeKlbPetaniKepKepIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/kep/create/': {
      id: '/_backoffice/klb-petani/kep/create/'
      path: '/klb-petani/kep/create'
      fullPath: '/klb-petani/kep/create'
      preLoaderRoute: typeof BackofficeKlbPetaniKepCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/kep/submission/': {
      id: '/_backoffice/klb-petani/kep/submission/'
      path: '/klb-petani/kep/submission'
      fullPath: '/klb-petani/kep/submission'
      preLoaderRoute: typeof BackofficeKlbPetaniKepSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/$petaniId/': {
      id: '/_backoffice/klb-petani/petani/$petaniId/'
      path: '/klb-petani/petani/$petaniId'
      fullPath: '/klb-petani/petani/$petaniId'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniPetaniIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/create/': {
      id: '/_backoffice/klb-petani/petani/create/'
      path: '/klb-petani/petani/create'
      fullPath: '/klb-petani/petani/create'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/submission/': {
      id: '/_backoffice/klb-petani/petani/submission/'
      path: '/klb-petani/petani/submission'
      fullPath: '/klb-petani/petani/submission'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/$poktanId/': {
      id: '/_backoffice/klb-petani/poktan/$poktanId/'
      path: '/klb-petani/poktan/$poktanId'
      fullPath: '/klb-petani/poktan/$poktanId'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanPoktanIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/create/': {
      id: '/_backoffice/klb-petani/poktan/create/'
      path: '/klb-petani/poktan/create'
      fullPath: '/klb-petani/poktan/create'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/submission/': {
      id: '/_backoffice/klb-petani/poktan/submission/'
      path: '/klb-petani/poktan/submission'
      fullPath: '/klb-petani/poktan/submission'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbd/$apbdId/': {
      id: '/_backoffice/ktg-penyuluh/apbd/$apbdId/'
      path: '/ktg-penyuluh/apbd/$apbdId'
      fullPath: '/ktg-penyuluh/apbd/$apbdId'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbdApbdIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbd/create/': {
      id: '/_backoffice/ktg-penyuluh/apbd/create/'
      path: '/ktg-penyuluh/apbd/create'
      fullPath: '/ktg-penyuluh/apbd/create'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbdCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbn/$apbnId/': {
      id: '/_backoffice/ktg-penyuluh/apbn/$apbnId/'
      path: '/ktg-penyuluh/apbn/$apbnId'
      fullPath: '/ktg-penyuluh/apbn/$apbnId'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbnApbnIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbn/create/': {
      id: '/_backoffice/ktg-penyuluh/apbn/create/'
      path: '/ktg-penyuluh/apbn/create'
      fullPath: '/ktg-penyuluh/apbn/create'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbnCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/': {
      id: '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/'
      path: '/ktg-penyuluh/pns-pppk/$pnsPppkId'
      fullPath: '/ktg-penyuluh/pns-pppk/$pnsPppkId'
      preLoaderRoute: typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/pns-pppk/create/': {
      id: '/_backoffice/ktg-penyuluh/pns-pppk/create/'
      path: '/ktg-penyuluh/pns-pppk/create'
      fullPath: '/ktg-penyuluh/pns-pppk/create'
      preLoaderRoute: typeof BackofficeKtgPenyuluhPnsPppkCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/': {
      id: '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/'
      path: '/ktg-penyuluh/swadaya/$swadayaId'
      fullPath: '/ktg-penyuluh/swadaya/$swadayaId'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwadayaSwadayaIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swadaya/create/': {
      id: '/_backoffice/ktg-penyuluh/swadaya/create/'
      path: '/ktg-penyuluh/swadaya/create'
      fullPath: '/ktg-penyuluh/swadaya/create'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwadayaCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swasta/$swastaId/': {
      id: '/_backoffice/ktg-penyuluh/swasta/$swastaId/'
      path: '/ktg-penyuluh/swasta/$swastaId'
      fullPath: '/ktg-penyuluh/swasta/$swastaId'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwastaSwastaIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swasta/create/': {
      id: '/_backoffice/ktg-penyuluh/swasta/create/'
      path: '/ktg-penyuluh/swasta/create'
      fullPath: '/ktg-penyuluh/swasta/create'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwastaCreateIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/report/pemetaan-wilker/$provinsiId/$kotaId/': {
      id: '/report/pemetaan-wilker/$provinsiId/$kotaId/'
      path: '/pemetaan-wilker/$provinsiId/$kotaId'
      fullPath: '/report/pemetaan-wilker/$provinsiId/$kotaId'
      preLoaderRoute: typeof ReportPemetaanWilkerProvinsiIdKotaIdIndexImport
      parentRoute: typeof ReportImport
    }
    '/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/': {
      id: '/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/'
      path: '/klb-penyuluh/provinsi/$provinsiId/edit'
      fullPath: '/klb-penyuluh/provinsi/$provinsiId/edit'
      preLoaderRoute: typeof BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-penyuluh/pusat/$pusatId/edit/': {
      id: '/_backoffice/klb-penyuluh/pusat/$pusatId/edit/'
      path: '/klb-penyuluh/pusat/$pusatId/edit'
      fullPath: '/klb-penyuluh/pusat/$pusatId/edit'
      preLoaderRoute: typeof BackofficeKlbPenyuluhPusatPusatIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/gapoktan/submission/$verificationId/': {
      id: '/_backoffice/klb-petani/gapoktan/submission/$verificationId/'
      path: '/klb-petani/gapoktan/submission/$verificationId'
      fullPath: '/klb-petani/gapoktan/submission/$verificationId'
      preLoaderRoute: typeof BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/kep/$kepId/edit/': {
      id: '/_backoffice/klb-petani/kep/$kepId/edit/'
      path: '/klb-petani/kep/$kepId/edit'
      fullPath: '/klb-petani/kep/$kepId/edit'
      preLoaderRoute: typeof BackofficeKlbPetaniKepKepIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/kep/submission/$verificationId/': {
      id: '/_backoffice/klb-petani/kep/submission/$verificationId/'
      path: '/klb-petani/kep/submission/$verificationId'
      fullPath: '/klb-petani/kep/submission/$verificationId'
      preLoaderRoute: typeof BackofficeKlbPetaniKepSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/submission/$verificationId/': {
      id: '/_backoffice/klb-petani/petani/submission/$verificationId/'
      path: '/klb-petani/petani/submission/$verificationId'
      fullPath: '/klb-petani/petani/submission/$verificationId'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/submission/$verificationId/': {
      id: '/_backoffice/klb-petani/poktan/submission/$verificationId/'
      path: '/klb-petani/poktan/submission/$verificationId'
      fullPath: '/klb-petani/poktan/submission/$verificationId'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/': {
      id: '/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/'
      path: '/ktg-penyuluh/apbd/$apbdId/edit'
      fullPath: '/ktg-penyuluh/apbd/$apbdId/edit'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbdApbdIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/': {
      id: '/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/'
      path: '/ktg-penyuluh/apbn/$apbnId/edit'
      fullPath: '/ktg-penyuluh/apbn/$apbnId/edit'
      preLoaderRoute: typeof BackofficeKtgPenyuluhApbnApbnIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/': {
      id: '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/'
      path: '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit'
      fullPath: '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit'
      preLoaderRoute: typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/': {
      id: '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/'
      path: '/ktg-penyuluh/swadaya/$swadayaId/edit'
      fullPath: '/ktg-penyuluh/swadaya/$swadayaId/edit'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/': {
      id: '/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/'
      path: '/ktg-penyuluh/swasta/$swastaId/edit'
      fullPath: '/ktg-penyuluh/swasta/$swastaId/edit'
      preLoaderRoute: typeof BackofficeKtgPenyuluhSwastaSwastaIdEditIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit': {
      id: '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
      path: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
      fullPath: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/': {
      id: '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/'
      path: '/klb-petani/petani/$petaniId/lahan/submission'
      fullPath: '/klb-petani/petani/$petaniId/lahan/submission'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/': {
      id: '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/'
      path: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId'
      fullPath: '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/': {
      id: '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/'
      path: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission'
      fullPath: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/': {
      id: '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/'
      path: '/klb-petani/petani/$petaniId/lahan/submission/$verificationId'
      fullPath: '/klb-petani/petani/$petaniId/lahan/submission/$verificationId'
      preLoaderRoute: typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
    '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/': {
      id: '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/'
      path: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId'
      fullPath: '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId'
      preLoaderRoute: typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexImport
      parentRoute: typeof BackofficeImport
    }
  }
}

// Create and export the route tree

interface BackofficeRouteChildren {
  BackofficeAboutIndexRoute: typeof BackofficeAboutIndexRoute
  BackofficeDashboardIndexRoute: typeof BackofficeDashboardIndexRoute
  BackofficeEditPenyuluhIndexRoute: typeof BackofficeEditPenyuluhIndexRoute
  BackofficeKlbPetaniIndexRoute: typeof BackofficeKlbPetaniIndexRoute
  BackofficeProfileIndexRoute: typeof BackofficeProfileIndexRoute
  BackofficeUserIndexRoute: typeof BackofficeUserIndexRoute
  BackofficeVerificationDataIndexRoute: typeof BackofficeVerificationDataIndexRoute
  BackofficeVerificationWilkerPenyuluhIndexRoute: typeof BackofficeVerificationWilkerPenyuluhIndexRoute
  BackofficeKlbPenyuluhDesaCreateRoute: typeof BackofficeKlbPenyuluhDesaCreateRoute
  BackofficeKlbPenyuluhKecamatanCreateRoute: typeof BackofficeKlbPenyuluhKecamatanCreateRoute
  BackofficeKlbPenyuluhKotakabCreateRoute: typeof BackofficeKlbPenyuluhKotakabCreateRoute
  BackofficeUserAdminCreateRoute: typeof BackofficeUserAdminCreateRoute
  BackofficeUserBppCreateRoute: typeof BackofficeUserBppCreateRoute
  BackofficeUserKabupatenCreateRoute: typeof BackofficeUserKabupatenCreateRoute
  BackofficeUserProvinsiCreateRoute: typeof BackofficeUserProvinsiCreateRoute
  BackofficeAboutCreateIndexRoute: typeof BackofficeAboutCreateIndexRoute
  BackofficeEditPenyuluhSubmissionIndexRoute: typeof BackofficeEditPenyuluhSubmissionIndexRoute
  BackofficeKlbPenyuluhDesaIndexRoute: typeof BackofficeKlbPenyuluhDesaIndexRoute
  BackofficeKlbPenyuluhKecamatanIndexRoute: typeof BackofficeKlbPenyuluhKecamatanIndexRoute
  BackofficeKlbPenyuluhKotakabIndexRoute: typeof BackofficeKlbPenyuluhKotakabIndexRoute
  BackofficeKlbPenyuluhProvinsiIndexRoute: typeof BackofficeKlbPenyuluhProvinsiIndexRoute
  BackofficeKlbPenyuluhPusatIndexRoute: typeof BackofficeKlbPenyuluhPusatIndexRoute
  BackofficeKlbPetaniCariPetaniIndexRoute: typeof BackofficeKlbPetaniCariPetaniIndexRoute
  BackofficeKlbPetaniGapoktanIndexRoute: typeof BackofficeKlbPetaniGapoktanIndexRoute
  BackofficeKlbPetaniKepIndexRoute: typeof BackofficeKlbPetaniKepIndexRoute
  BackofficeKlbPetaniPetaniIndexRoute: typeof BackofficeKlbPetaniPetaniIndexRoute
  BackofficeKlbPetaniPoktanIndexRoute: typeof BackofficeKlbPetaniPoktanIndexRoute
  BackofficeKtgPenyuluhApbdIndexRoute: typeof BackofficeKtgPenyuluhApbdIndexRoute
  BackofficeKtgPenyuluhApbnIndexRoute: typeof BackofficeKtgPenyuluhApbnIndexRoute
  BackofficeKtgPenyuluhPindahDomisiliIndexRoute: typeof BackofficeKtgPenyuluhPindahDomisiliIndexRoute
  BackofficeKtgPenyuluhPnsPppkIndexRoute: typeof BackofficeKtgPenyuluhPnsPppkIndexRoute
  BackofficeKtgPenyuluhSwadayaIndexRoute: typeof BackofficeKtgPenyuluhSwadayaIndexRoute
  BackofficeKtgPenyuluhSwastaIndexRoute: typeof BackofficeKtgPenyuluhSwastaIndexRoute
  BackofficeUserAdminIndexRoute: typeof BackofficeUserAdminIndexRoute
  BackofficeUserBppIndexRoute: typeof BackofficeUserBppIndexRoute
  BackofficeUserKabupatenIndexRoute: typeof BackofficeUserKabupatenIndexRoute
  BackofficeUserProvinsiIndexRoute: typeof BackofficeUserProvinsiIndexRoute
  BackofficeVerificationDataVerificationIdIndexRoute: typeof BackofficeVerificationDataVerificationIdIndexRoute
  BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute: typeof BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute
  BackofficeKlbPenyuluhKecamatanBppIdEditRoute: typeof BackofficeKlbPenyuluhKecamatanBppIdEditRoute
  BackofficeKlbPenyuluhKotakabKotakabIdEditRoute: typeof BackofficeKlbPenyuluhKotakabKotakabIdEditRoute
  BackofficeKlbPetaniGapoktanGapoktanIdEditRoute: typeof BackofficeKlbPetaniGapoktanGapoktanIdEditRoute
  BackofficeKlbPetaniPetaniPetaniIdEditRoute: typeof BackofficeKlbPetaniPetaniPetaniIdEditRoute
  BackofficeKlbPetaniPoktanPoktanIdEditRoute: typeof BackofficeKlbPetaniPoktanPoktanIdEditRoute
  BackofficeUserAdminAdminIdEditRoute: typeof BackofficeUserAdminAdminIdEditRoute
  BackofficeUserBppAdminIdEditRoute: typeof BackofficeUserBppAdminIdEditRoute
  BackofficeUserKabupatenAdminIdEditRoute: typeof BackofficeUserKabupatenAdminIdEditRoute
  BackofficeUserProvinsiAdminIdEditRoute: typeof BackofficeUserProvinsiAdminIdEditRoute
  BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute: typeof BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute
  BackofficeKlbPenyuluhKecamatanBppIdIndexRoute: typeof BackofficeKlbPenyuluhKecamatanBppIdIndexRoute
  BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute: typeof BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute
  BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute: typeof BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute
  BackofficeKlbPenyuluhProvinsiCreateIndexRoute: typeof BackofficeKlbPenyuluhProvinsiCreateIndexRoute
  BackofficeKlbPenyuluhPusatPusatIdIndexRoute: typeof BackofficeKlbPenyuluhPusatPusatIdIndexRoute
  BackofficeKlbPenyuluhPusatCreateIndexRoute: typeof BackofficeKlbPenyuluhPusatCreateIndexRoute
  BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute: typeof BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute
  BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute: typeof BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute
  BackofficeKlbPetaniGapoktanCreateIndexRoute: typeof BackofficeKlbPetaniGapoktanCreateIndexRoute
  BackofficeKlbPetaniGapoktanSubmissionIndexRoute: typeof BackofficeKlbPetaniGapoktanSubmissionIndexRoute
  BackofficeKlbPetaniKepKepIdIndexRoute: typeof BackofficeKlbPetaniKepKepIdIndexRoute
  BackofficeKlbPetaniKepCreateIndexRoute: typeof BackofficeKlbPetaniKepCreateIndexRoute
  BackofficeKlbPetaniKepSubmissionIndexRoute: typeof BackofficeKlbPetaniKepSubmissionIndexRoute
  BackofficeKlbPetaniPetaniPetaniIdIndexRoute: typeof BackofficeKlbPetaniPetaniPetaniIdIndexRoute
  BackofficeKlbPetaniPetaniCreateIndexRoute: typeof BackofficeKlbPetaniPetaniCreateIndexRoute
  BackofficeKlbPetaniPetaniSubmissionIndexRoute: typeof BackofficeKlbPetaniPetaniSubmissionIndexRoute
  BackofficeKlbPetaniPoktanPoktanIdIndexRoute: typeof BackofficeKlbPetaniPoktanPoktanIdIndexRoute
  BackofficeKlbPetaniPoktanCreateIndexRoute: typeof BackofficeKlbPetaniPoktanCreateIndexRoute
  BackofficeKlbPetaniPoktanSubmissionIndexRoute: typeof BackofficeKlbPetaniPoktanSubmissionIndexRoute
  BackofficeKtgPenyuluhApbdApbdIdIndexRoute: typeof BackofficeKtgPenyuluhApbdApbdIdIndexRoute
  BackofficeKtgPenyuluhApbdCreateIndexRoute: typeof BackofficeKtgPenyuluhApbdCreateIndexRoute
  BackofficeKtgPenyuluhApbnApbnIdIndexRoute: typeof BackofficeKtgPenyuluhApbnApbnIdIndexRoute
  BackofficeKtgPenyuluhApbnCreateIndexRoute: typeof BackofficeKtgPenyuluhApbnCreateIndexRoute
  BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute: typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute
  BackofficeKtgPenyuluhPnsPppkCreateIndexRoute: typeof BackofficeKtgPenyuluhPnsPppkCreateIndexRoute
  BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute: typeof BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute
  BackofficeKtgPenyuluhSwadayaCreateIndexRoute: typeof BackofficeKtgPenyuluhSwadayaCreateIndexRoute
  BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute: typeof BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute
  BackofficeKtgPenyuluhSwastaCreateIndexRoute: typeof BackofficeKtgPenyuluhSwastaCreateIndexRoute
  BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute: typeof BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute
  BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute: typeof BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute
  BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute: typeof BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute
  BackofficeKlbPetaniKepKepIdEditIndexRoute: typeof BackofficeKlbPetaniKepKepIdEditIndexRoute
  BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute: typeof BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute
  BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute: typeof BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute
  BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute: typeof BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute
  BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute: typeof BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute
  BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute: typeof BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute
  BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute: typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute
  BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute: typeof BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute
  BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute: typeof BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute
  BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute: typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute
  BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute: typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute
  BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute: typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute
  BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute: typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute
  BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute: typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute
  BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute: typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute
}

const BackofficeRouteChildren: BackofficeRouteChildren = {
  BackofficeAboutIndexRoute: BackofficeAboutIndexRoute,
  BackofficeDashboardIndexRoute: BackofficeDashboardIndexRoute,
  BackofficeEditPenyuluhIndexRoute: BackofficeEditPenyuluhIndexRoute,
  BackofficeKlbPetaniIndexRoute: BackofficeKlbPetaniIndexRoute,
  BackofficeProfileIndexRoute: BackofficeProfileIndexRoute,
  BackofficeUserIndexRoute: BackofficeUserIndexRoute,
  BackofficeVerificationDataIndexRoute: BackofficeVerificationDataIndexRoute,
  BackofficeVerificationWilkerPenyuluhIndexRoute:
    BackofficeVerificationWilkerPenyuluhIndexRoute,
  BackofficeKlbPenyuluhDesaCreateRoute: BackofficeKlbPenyuluhDesaCreateRoute,
  BackofficeKlbPenyuluhKecamatanCreateRoute:
    BackofficeKlbPenyuluhKecamatanCreateRoute,
  BackofficeKlbPenyuluhKotakabCreateRoute:
    BackofficeKlbPenyuluhKotakabCreateRoute,
  BackofficeUserAdminCreateRoute: BackofficeUserAdminCreateRoute,
  BackofficeUserBppCreateRoute: BackofficeUserBppCreateRoute,
  BackofficeUserKabupatenCreateRoute: BackofficeUserKabupatenCreateRoute,
  BackofficeUserProvinsiCreateRoute: BackofficeUserProvinsiCreateRoute,
  BackofficeAboutCreateIndexRoute: BackofficeAboutCreateIndexRoute,
  BackofficeEditPenyuluhSubmissionIndexRoute:
    BackofficeEditPenyuluhSubmissionIndexRoute,
  BackofficeKlbPenyuluhDesaIndexRoute: BackofficeKlbPenyuluhDesaIndexRoute,
  BackofficeKlbPenyuluhKecamatanIndexRoute:
    BackofficeKlbPenyuluhKecamatanIndexRoute,
  BackofficeKlbPenyuluhKotakabIndexRoute:
    BackofficeKlbPenyuluhKotakabIndexRoute,
  BackofficeKlbPenyuluhProvinsiIndexRoute:
    BackofficeKlbPenyuluhProvinsiIndexRoute,
  BackofficeKlbPenyuluhPusatIndexRoute: BackofficeKlbPenyuluhPusatIndexRoute,
  BackofficeKlbPetaniCariPetaniIndexRoute:
    BackofficeKlbPetaniCariPetaniIndexRoute,
  BackofficeKlbPetaniGapoktanIndexRoute: BackofficeKlbPetaniGapoktanIndexRoute,
  BackofficeKlbPetaniKepIndexRoute: BackofficeKlbPetaniKepIndexRoute,
  BackofficeKlbPetaniPetaniIndexRoute: BackofficeKlbPetaniPetaniIndexRoute,
  BackofficeKlbPetaniPoktanIndexRoute: BackofficeKlbPetaniPoktanIndexRoute,
  BackofficeKtgPenyuluhApbdIndexRoute: BackofficeKtgPenyuluhApbdIndexRoute,
  BackofficeKtgPenyuluhApbnIndexRoute: BackofficeKtgPenyuluhApbnIndexRoute,
  BackofficeKtgPenyuluhPindahDomisiliIndexRoute:
    BackofficeKtgPenyuluhPindahDomisiliIndexRoute,
  BackofficeKtgPenyuluhPnsPppkIndexRoute:
    BackofficeKtgPenyuluhPnsPppkIndexRoute,
  BackofficeKtgPenyuluhSwadayaIndexRoute:
    BackofficeKtgPenyuluhSwadayaIndexRoute,
  BackofficeKtgPenyuluhSwastaIndexRoute: BackofficeKtgPenyuluhSwastaIndexRoute,
  BackofficeUserAdminIndexRoute: BackofficeUserAdminIndexRoute,
  BackofficeUserBppIndexRoute: BackofficeUserBppIndexRoute,
  BackofficeUserKabupatenIndexRoute: BackofficeUserKabupatenIndexRoute,
  BackofficeUserProvinsiIndexRoute: BackofficeUserProvinsiIndexRoute,
  BackofficeVerificationDataVerificationIdIndexRoute:
    BackofficeVerificationDataVerificationIdIndexRoute,
  BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute:
    BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute,
  BackofficeKlbPenyuluhKecamatanBppIdEditRoute:
    BackofficeKlbPenyuluhKecamatanBppIdEditRoute,
  BackofficeKlbPenyuluhKotakabKotakabIdEditRoute:
    BackofficeKlbPenyuluhKotakabKotakabIdEditRoute,
  BackofficeKlbPetaniGapoktanGapoktanIdEditRoute:
    BackofficeKlbPetaniGapoktanGapoktanIdEditRoute,
  BackofficeKlbPetaniPetaniPetaniIdEditRoute:
    BackofficeKlbPetaniPetaniPetaniIdEditRoute,
  BackofficeKlbPetaniPoktanPoktanIdEditRoute:
    BackofficeKlbPetaniPoktanPoktanIdEditRoute,
  BackofficeUserAdminAdminIdEditRoute: BackofficeUserAdminAdminIdEditRoute,
  BackofficeUserBppAdminIdEditRoute: BackofficeUserBppAdminIdEditRoute,
  BackofficeUserKabupatenAdminIdEditRoute:
    BackofficeUserKabupatenAdminIdEditRoute,
  BackofficeUserProvinsiAdminIdEditRoute:
    BackofficeUserProvinsiAdminIdEditRoute,
  BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute:
    BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute,
  BackofficeKlbPenyuluhKecamatanBppIdIndexRoute:
    BackofficeKlbPenyuluhKecamatanBppIdIndexRoute,
  BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute:
    BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute,
  BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute:
    BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute,
  BackofficeKlbPenyuluhProvinsiCreateIndexRoute:
    BackofficeKlbPenyuluhProvinsiCreateIndexRoute,
  BackofficeKlbPenyuluhPusatPusatIdIndexRoute:
    BackofficeKlbPenyuluhPusatPusatIdIndexRoute,
  BackofficeKlbPenyuluhPusatCreateIndexRoute:
    BackofficeKlbPenyuluhPusatCreateIndexRoute,
  BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute:
    BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute,
  BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute:
    BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute,
  BackofficeKlbPetaniGapoktanCreateIndexRoute:
    BackofficeKlbPetaniGapoktanCreateIndexRoute,
  BackofficeKlbPetaniGapoktanSubmissionIndexRoute:
    BackofficeKlbPetaniGapoktanSubmissionIndexRoute,
  BackofficeKlbPetaniKepKepIdIndexRoute: BackofficeKlbPetaniKepKepIdIndexRoute,
  BackofficeKlbPetaniKepCreateIndexRoute:
    BackofficeKlbPetaniKepCreateIndexRoute,
  BackofficeKlbPetaniKepSubmissionIndexRoute:
    BackofficeKlbPetaniKepSubmissionIndexRoute,
  BackofficeKlbPetaniPetaniPetaniIdIndexRoute:
    BackofficeKlbPetaniPetaniPetaniIdIndexRoute,
  BackofficeKlbPetaniPetaniCreateIndexRoute:
    BackofficeKlbPetaniPetaniCreateIndexRoute,
  BackofficeKlbPetaniPetaniSubmissionIndexRoute:
    BackofficeKlbPetaniPetaniSubmissionIndexRoute,
  BackofficeKlbPetaniPoktanPoktanIdIndexRoute:
    BackofficeKlbPetaniPoktanPoktanIdIndexRoute,
  BackofficeKlbPetaniPoktanCreateIndexRoute:
    BackofficeKlbPetaniPoktanCreateIndexRoute,
  BackofficeKlbPetaniPoktanSubmissionIndexRoute:
    BackofficeKlbPetaniPoktanSubmissionIndexRoute,
  BackofficeKtgPenyuluhApbdApbdIdIndexRoute:
    BackofficeKtgPenyuluhApbdApbdIdIndexRoute,
  BackofficeKtgPenyuluhApbdCreateIndexRoute:
    BackofficeKtgPenyuluhApbdCreateIndexRoute,
  BackofficeKtgPenyuluhApbnApbnIdIndexRoute:
    BackofficeKtgPenyuluhApbnApbnIdIndexRoute,
  BackofficeKtgPenyuluhApbnCreateIndexRoute:
    BackofficeKtgPenyuluhApbnCreateIndexRoute,
  BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute:
    BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute,
  BackofficeKtgPenyuluhPnsPppkCreateIndexRoute:
    BackofficeKtgPenyuluhPnsPppkCreateIndexRoute,
  BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute:
    BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute,
  BackofficeKtgPenyuluhSwadayaCreateIndexRoute:
    BackofficeKtgPenyuluhSwadayaCreateIndexRoute,
  BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute:
    BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute,
  BackofficeKtgPenyuluhSwastaCreateIndexRoute:
    BackofficeKtgPenyuluhSwastaCreateIndexRoute,
  BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute:
    BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute,
  BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute:
    BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute,
  BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute:
    BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute,
  BackofficeKlbPetaniKepKepIdEditIndexRoute:
    BackofficeKlbPetaniKepKepIdEditIndexRoute,
  BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute:
    BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute,
  BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute:
    BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute,
  BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute:
    BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute,
  BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute:
    BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute,
  BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute:
    BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute,
  BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute:
    BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute,
  BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute:
    BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute,
  BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute:
    BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute,
  BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute:
    BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute,
  BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute:
    BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute,
  BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute:
    BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute,
  BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute:
    BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute,
  BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute:
    BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute,
  BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute:
    BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute,
}

const BackofficeRouteWithChildren = BackofficeRoute._addFileChildren(
  BackofficeRouteChildren,
)

interface GuestRouteChildren {
  GuestGuestKtgWorkerListRoute: typeof GuestGuestKtgWorkerListRoute
  GuestGuestListGapoktanRoute: typeof GuestGuestListGapoktanRoute
  GuestGuestListKepRoute: typeof GuestGuestListKepRoute
  GuestGuestListPoktanRoute: typeof GuestGuestListPoktanRoute
  GuestGuestListPoktanMemberRoute: typeof GuestGuestListPoktanMemberRoute
  GuestGuestRecapClassPoktanRoute: typeof GuestGuestRecapClassPoktanRoute
  GuestGuestRecapClassificationsBppRoute: typeof GuestGuestRecapClassificationsBppRoute
  GuestGuestRecapExtensionsInstitutionsRoute: typeof GuestGuestRecapExtensionsInstitutionsRoute
  GuestGuestRecapExtentionsWorkerRoute: typeof GuestGuestRecapExtentionsWorkerRoute
  GuestGuestRecapFarmerInstitutionsRoute: typeof GuestGuestRecapFarmerInstitutionsRoute
  GuestGuestRecapPoktanRoute: typeof GuestGuestRecapPoktanRoute
  GuestGuestRecapShapeKepRoute: typeof GuestGuestRecapShapeKepRoute
  GuestGuestIndexRoute: typeof GuestGuestIndexRoute
  GuestGuestSearchFarmerPoktanMembersRoute: typeof GuestGuestSearchFarmerPoktanMembersRoute
  GuestGuestSearchKlbFarmersRoute: typeof GuestGuestSearchKlbFarmersRoute
  GuestGuestSearchKtgExtensionsInstitutionsRoute: typeof GuestGuestSearchKtgExtensionsInstitutionsRoute
  GuestGuestExtensionsInstitutionsIndexRoute: typeof GuestGuestExtensionsInstitutionsIndexRoute
  GuestGuestExtensionsInstitutionsBppIdRoute: typeof GuestGuestExtensionsInstitutionsBppIdRoute
  GuestGuestExtensionsInstitutionsCityIdRoute: typeof GuestGuestExtensionsInstitutionsCityIdRoute
  GuestGuestExtensionsInstitutionsPosluhdesIdRoute: typeof GuestGuestExtensionsInstitutionsPosluhdesIdRoute
  GuestGuestExtensionsInstitutionsProvinceIdRoute: typeof GuestGuestExtensionsInstitutionsProvinceIdRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestGuestKtgWorkerListRoute: GuestGuestKtgWorkerListRoute,
  GuestGuestListGapoktanRoute: GuestGuestListGapoktanRoute,
  GuestGuestListKepRoute: GuestGuestListKepRoute,
  GuestGuestListPoktanRoute: GuestGuestListPoktanRoute,
  GuestGuestListPoktanMemberRoute: GuestGuestListPoktanMemberRoute,
  GuestGuestRecapClassPoktanRoute: GuestGuestRecapClassPoktanRoute,
  GuestGuestRecapClassificationsBppRoute:
    GuestGuestRecapClassificationsBppRoute,
  GuestGuestRecapExtensionsInstitutionsRoute:
    GuestGuestRecapExtensionsInstitutionsRoute,
  GuestGuestRecapExtentionsWorkerRoute: GuestGuestRecapExtentionsWorkerRoute,
  GuestGuestRecapFarmerInstitutionsRoute:
    GuestGuestRecapFarmerInstitutionsRoute,
  GuestGuestRecapPoktanRoute: GuestGuestRecapPoktanRoute,
  GuestGuestRecapShapeKepRoute: GuestGuestRecapShapeKepRoute,
  GuestGuestIndexRoute: GuestGuestIndexRoute,
  GuestGuestSearchFarmerPoktanMembersRoute:
    GuestGuestSearchFarmerPoktanMembersRoute,
  GuestGuestSearchKlbFarmersRoute: GuestGuestSearchKlbFarmersRoute,
  GuestGuestSearchKtgExtensionsInstitutionsRoute:
    GuestGuestSearchKtgExtensionsInstitutionsRoute,
  GuestGuestExtensionsInstitutionsIndexRoute:
    GuestGuestExtensionsInstitutionsIndexRoute,
  GuestGuestExtensionsInstitutionsBppIdRoute:
    GuestGuestExtensionsInstitutionsBppIdRoute,
  GuestGuestExtensionsInstitutionsCityIdRoute:
    GuestGuestExtensionsInstitutionsCityIdRoute,
  GuestGuestExtensionsInstitutionsPosluhdesIdRoute:
    GuestGuestExtensionsInstitutionsPosluhdesIdRoute,
  GuestGuestExtensionsInstitutionsProvinceIdRoute:
    GuestGuestExtensionsInstitutionsProvinceIdRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

interface ReportRouteChildren {
  ReportPemetaanWilkerIndexRoute: typeof ReportPemetaanWilkerIndexRoute
  ReportPemetaanWilkerProvinsiIdIndexRoute: typeof ReportPemetaanWilkerProvinsiIdIndexRoute
  ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute: typeof ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute
}

const ReportRouteChildren: ReportRouteChildren = {
  ReportPemetaanWilkerIndexRoute: ReportPemetaanWilkerIndexRoute,
  ReportPemetaanWilkerProvinsiIdIndexRoute:
    ReportPemetaanWilkerProvinsiIdIndexRoute,
  ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute:
    ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute,
}

const ReportRouteWithChildren =
  ReportRoute._addFileChildren(ReportRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '': typeof GuestRouteWithChildren
  '/report': typeof ReportRouteWithChildren
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/guest/ktg-worker-list': typeof GuestGuestKtgWorkerListRoute
  '/guest/list-gapoktan': typeof GuestGuestListGapoktanRoute
  '/guest/list-kep': typeof GuestGuestListKepRoute
  '/guest/list-poktan': typeof GuestGuestListPoktanRoute
  '/guest/list-poktan-member': typeof GuestGuestListPoktanMemberRoute
  '/guest/recap-class-poktan': typeof GuestGuestRecapClassPoktanRoute
  '/guest/recap-classifications-bpp': typeof GuestGuestRecapClassificationsBppRoute
  '/guest/recap-extensions-institutions': typeof GuestGuestRecapExtensionsInstitutionsRoute
  '/guest/recap-extentions-worker': typeof GuestGuestRecapExtentionsWorkerRoute
  '/guest/recap-farmer-institutions': typeof GuestGuestRecapFarmerInstitutionsRoute
  '/guest/recap-poktan': typeof GuestGuestRecapPoktanRoute
  '/guest/recap-shape-kep': typeof GuestGuestRecapShapeKepRoute
  '/oauth/simluhtan/callback': typeof OauthSimluhtanCallbackRoute
  '/about': typeof BackofficeAboutIndexRoute
  '/dashboard': typeof BackofficeDashboardIndexRoute
  '/edit-penyuluh': typeof BackofficeEditPenyuluhIndexRoute
  '/klb-petani': typeof BackofficeKlbPetaniIndexRoute
  '/profile': typeof BackofficeProfileIndexRoute
  '/user': typeof BackofficeUserIndexRoute
  '/verification-data': typeof BackofficeVerificationDataIndexRoute
  '/verification-wilker-penyuluh': typeof BackofficeVerificationWilkerPenyuluhIndexRoute
  '/guest': typeof GuestGuestIndexRoute
  '/report/pemetaan-wilker': typeof ReportPemetaanWilkerIndexRoute
  '/klb-penyuluh/desa/create': typeof BackofficeKlbPenyuluhDesaCreateRoute
  '/klb-penyuluh/kecamatan/create': typeof BackofficeKlbPenyuluhKecamatanCreateRoute
  '/klb-penyuluh/kotakab/create': typeof BackofficeKlbPenyuluhKotakabCreateRoute
  '/user/admin/create': typeof BackofficeUserAdminCreateRoute
  '/user/bpp/create': typeof BackofficeUserBppCreateRoute
  '/user/kabupaten/create': typeof BackofficeUserKabupatenCreateRoute
  '/user/provinsi/create': typeof BackofficeUserProvinsiCreateRoute
  '/guest/search/farmer-poktan-members': typeof GuestGuestSearchFarmerPoktanMembersRoute
  '/guest/search/klb-farmers': typeof GuestGuestSearchKlbFarmersRoute
  '/guest/search/ktg-extensions-institutions': typeof GuestGuestSearchKtgExtensionsInstitutionsRoute
  '/about/create': typeof BackofficeAboutCreateIndexRoute
  '/edit-penyuluh/submission': typeof BackofficeEditPenyuluhSubmissionIndexRoute
  '/klb-penyuluh/desa': typeof BackofficeKlbPenyuluhDesaIndexRoute
  '/klb-penyuluh/kecamatan': typeof BackofficeKlbPenyuluhKecamatanIndexRoute
  '/klb-penyuluh/kotakab': typeof BackofficeKlbPenyuluhKotakabIndexRoute
  '/klb-penyuluh/provinsi': typeof BackofficeKlbPenyuluhProvinsiIndexRoute
  '/klb-penyuluh/pusat': typeof BackofficeKlbPenyuluhPusatIndexRoute
  '/klb-petani/cari-petani': typeof BackofficeKlbPetaniCariPetaniIndexRoute
  '/klb-petani/gapoktan': typeof BackofficeKlbPetaniGapoktanIndexRoute
  '/klb-petani/kep': typeof BackofficeKlbPetaniKepIndexRoute
  '/klb-petani/petani': typeof BackofficeKlbPetaniPetaniIndexRoute
  '/klb-petani/poktan': typeof BackofficeKlbPetaniPoktanIndexRoute
  '/ktg-penyuluh/apbd': typeof BackofficeKtgPenyuluhApbdIndexRoute
  '/ktg-penyuluh/apbn': typeof BackofficeKtgPenyuluhApbnIndexRoute
  '/ktg-penyuluh/pindah-domisili': typeof BackofficeKtgPenyuluhPindahDomisiliIndexRoute
  '/ktg-penyuluh/pns-pppk': typeof BackofficeKtgPenyuluhPnsPppkIndexRoute
  '/ktg-penyuluh/swadaya': typeof BackofficeKtgPenyuluhSwadayaIndexRoute
  '/ktg-penyuluh/swasta': typeof BackofficeKtgPenyuluhSwastaIndexRoute
  '/user/admin': typeof BackofficeUserAdminIndexRoute
  '/user/bpp': typeof BackofficeUserBppIndexRoute
  '/user/kabupaten': typeof BackofficeUserKabupatenIndexRoute
  '/user/provinsi': typeof BackofficeUserProvinsiIndexRoute
  '/verification-data/$verificationId': typeof BackofficeVerificationDataVerificationIdIndexRoute
  '/guest/extensions-institutions': typeof GuestGuestExtensionsInstitutionsIndexRoute
  '/report/pemetaan-wilker/$provinsiId': typeof ReportPemetaanWilkerProvinsiIdIndexRoute
  '/klb-penyuluh/desa/$penyuluhId/edit': typeof BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute
  '/klb-penyuluh/kecamatan/$bppId/edit': typeof BackofficeKlbPenyuluhKecamatanBppIdEditRoute
  '/klb-penyuluh/kotakab/$kotakabId/edit': typeof BackofficeKlbPenyuluhKotakabKotakabIdEditRoute
  '/klb-petani/gapoktan/$gapoktanId/edit': typeof BackofficeKlbPetaniGapoktanGapoktanIdEditRoute
  '/klb-petani/petani/$petaniId/edit': typeof BackofficeKlbPetaniPetaniPetaniIdEditRoute
  '/klb-petani/poktan/$poktanId/edit': typeof BackofficeKlbPetaniPoktanPoktanIdEditRoute
  '/user/admin/$adminId/edit': typeof BackofficeUserAdminAdminIdEditRoute
  '/user/bpp/$adminId/edit': typeof BackofficeUserBppAdminIdEditRoute
  '/user/kabupaten/$adminId/edit': typeof BackofficeUserKabupatenAdminIdEditRoute
  '/user/provinsi/$adminId/edit': typeof BackofficeUserProvinsiAdminIdEditRoute
  '/guest/extensions-institutions/bpp/$id': typeof GuestGuestExtensionsInstitutionsBppIdRoute
  '/guest/extensions-institutions/city/$id': typeof GuestGuestExtensionsInstitutionsCityIdRoute
  '/guest/extensions-institutions/posluhdes/$id': typeof GuestGuestExtensionsInstitutionsPosluhdesIdRoute
  '/guest/extensions-institutions/province/$id': typeof GuestGuestExtensionsInstitutionsProvinceIdRoute
  '/edit-penyuluh/submission/$verificationId': typeof BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute
  '/klb-penyuluh/kecamatan/$bppId': typeof BackofficeKlbPenyuluhKecamatanBppIdIndexRoute
  '/klb-penyuluh/kotakab/$kotakabId': typeof BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute
  '/klb-penyuluh/provinsi/$provinsiId': typeof BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute
  '/klb-penyuluh/provinsi/create': typeof BackofficeKlbPenyuluhProvinsiCreateIndexRoute
  '/klb-penyuluh/pusat/$pusatId': typeof BackofficeKlbPenyuluhPusatPusatIdIndexRoute
  '/klb-penyuluh/pusat/create': typeof BackofficeKlbPenyuluhPusatCreateIndexRoute
  '/klb-petani/cari-petani/$cariPetaniId': typeof BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute
  '/klb-petani/gapoktan/$gapoktanId': typeof BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute
  '/klb-petani/gapoktan/create': typeof BackofficeKlbPetaniGapoktanCreateIndexRoute
  '/klb-petani/gapoktan/submission': typeof BackofficeKlbPetaniGapoktanSubmissionIndexRoute
  '/klb-petani/kep/$kepId': typeof BackofficeKlbPetaniKepKepIdIndexRoute
  '/klb-petani/kep/create': typeof BackofficeKlbPetaniKepCreateIndexRoute
  '/klb-petani/kep/submission': typeof BackofficeKlbPetaniKepSubmissionIndexRoute
  '/klb-petani/petani/$petaniId': typeof BackofficeKlbPetaniPetaniPetaniIdIndexRoute
  '/klb-petani/petani/create': typeof BackofficeKlbPetaniPetaniCreateIndexRoute
  '/klb-petani/petani/submission': typeof BackofficeKlbPetaniPetaniSubmissionIndexRoute
  '/klb-petani/poktan/$poktanId': typeof BackofficeKlbPetaniPoktanPoktanIdIndexRoute
  '/klb-petani/poktan/create': typeof BackofficeKlbPetaniPoktanCreateIndexRoute
  '/klb-petani/poktan/submission': typeof BackofficeKlbPetaniPoktanSubmissionIndexRoute
  '/ktg-penyuluh/apbd/$apbdId': typeof BackofficeKtgPenyuluhApbdApbdIdIndexRoute
  '/ktg-penyuluh/apbd/create': typeof BackofficeKtgPenyuluhApbdCreateIndexRoute
  '/ktg-penyuluh/apbn/$apbnId': typeof BackofficeKtgPenyuluhApbnApbnIdIndexRoute
  '/ktg-penyuluh/apbn/create': typeof BackofficeKtgPenyuluhApbnCreateIndexRoute
  '/ktg-penyuluh/pns-pppk/$pnsPppkId': typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute
  '/ktg-penyuluh/pns-pppk/create': typeof BackofficeKtgPenyuluhPnsPppkCreateIndexRoute
  '/ktg-penyuluh/swadaya/$swadayaId': typeof BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute
  '/ktg-penyuluh/swadaya/create': typeof BackofficeKtgPenyuluhSwadayaCreateIndexRoute
  '/ktg-penyuluh/swasta/$swastaId': typeof BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute
  '/ktg-penyuluh/swasta/create': typeof BackofficeKtgPenyuluhSwastaCreateIndexRoute
  '/report/pemetaan-wilker/$provinsiId/$kotaId': typeof ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute
  '/klb-penyuluh/provinsi/$provinsiId/edit': typeof BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute
  '/klb-penyuluh/pusat/$pusatId/edit': typeof BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute
  '/klb-petani/gapoktan/submission/$verificationId': typeof BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute
  '/klb-petani/kep/$kepId/edit': typeof BackofficeKlbPetaniKepKepIdEditIndexRoute
  '/klb-petani/kep/submission/$verificationId': typeof BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute
  '/klb-petani/petani/submission/$verificationId': typeof BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute
  '/klb-petani/poktan/submission/$verificationId': typeof BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute
  '/ktg-penyuluh/apbd/$apbdId/edit': typeof BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute
  '/ktg-penyuluh/apbn/$apbnId/edit': typeof BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute
  '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit': typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute
  '/ktg-penyuluh/swadaya/$swadayaId/edit': typeof BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute
  '/ktg-penyuluh/swasta/$swastaId/edit': typeof BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute
  '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit': typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute
  '/klb-petani/petani/$petaniId/lahan/submission': typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute
  '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId': typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute
  '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission': typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute
  '/klb-petani/petani/$petaniId/lahan/submission/$verificationId': typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute
  '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId': typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '': typeof GuestRouteWithChildren
  '/report': typeof ReportRouteWithChildren
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/guest/ktg-worker-list': typeof GuestGuestKtgWorkerListRoute
  '/guest/list-gapoktan': typeof GuestGuestListGapoktanRoute
  '/guest/list-kep': typeof GuestGuestListKepRoute
  '/guest/list-poktan': typeof GuestGuestListPoktanRoute
  '/guest/list-poktan-member': typeof GuestGuestListPoktanMemberRoute
  '/guest/recap-class-poktan': typeof GuestGuestRecapClassPoktanRoute
  '/guest/recap-classifications-bpp': typeof GuestGuestRecapClassificationsBppRoute
  '/guest/recap-extensions-institutions': typeof GuestGuestRecapExtensionsInstitutionsRoute
  '/guest/recap-extentions-worker': typeof GuestGuestRecapExtentionsWorkerRoute
  '/guest/recap-farmer-institutions': typeof GuestGuestRecapFarmerInstitutionsRoute
  '/guest/recap-poktan': typeof GuestGuestRecapPoktanRoute
  '/guest/recap-shape-kep': typeof GuestGuestRecapShapeKepRoute
  '/oauth/simluhtan/callback': typeof OauthSimluhtanCallbackRoute
  '/about': typeof BackofficeAboutIndexRoute
  '/dashboard': typeof BackofficeDashboardIndexRoute
  '/edit-penyuluh': typeof BackofficeEditPenyuluhIndexRoute
  '/klb-petani': typeof BackofficeKlbPetaniIndexRoute
  '/profile': typeof BackofficeProfileIndexRoute
  '/user': typeof BackofficeUserIndexRoute
  '/verification-data': typeof BackofficeVerificationDataIndexRoute
  '/verification-wilker-penyuluh': typeof BackofficeVerificationWilkerPenyuluhIndexRoute
  '/guest': typeof GuestGuestIndexRoute
  '/report/pemetaan-wilker': typeof ReportPemetaanWilkerIndexRoute
  '/klb-penyuluh/desa/create': typeof BackofficeKlbPenyuluhDesaCreateRoute
  '/klb-penyuluh/kecamatan/create': typeof BackofficeKlbPenyuluhKecamatanCreateRoute
  '/klb-penyuluh/kotakab/create': typeof BackofficeKlbPenyuluhKotakabCreateRoute
  '/user/admin/create': typeof BackofficeUserAdminCreateRoute
  '/user/bpp/create': typeof BackofficeUserBppCreateRoute
  '/user/kabupaten/create': typeof BackofficeUserKabupatenCreateRoute
  '/user/provinsi/create': typeof BackofficeUserProvinsiCreateRoute
  '/guest/search/farmer-poktan-members': typeof GuestGuestSearchFarmerPoktanMembersRoute
  '/guest/search/klb-farmers': typeof GuestGuestSearchKlbFarmersRoute
  '/guest/search/ktg-extensions-institutions': typeof GuestGuestSearchKtgExtensionsInstitutionsRoute
  '/about/create': typeof BackofficeAboutCreateIndexRoute
  '/edit-penyuluh/submission': typeof BackofficeEditPenyuluhSubmissionIndexRoute
  '/klb-penyuluh/desa': typeof BackofficeKlbPenyuluhDesaIndexRoute
  '/klb-penyuluh/kecamatan': typeof BackofficeKlbPenyuluhKecamatanIndexRoute
  '/klb-penyuluh/kotakab': typeof BackofficeKlbPenyuluhKotakabIndexRoute
  '/klb-penyuluh/provinsi': typeof BackofficeKlbPenyuluhProvinsiIndexRoute
  '/klb-penyuluh/pusat': typeof BackofficeKlbPenyuluhPusatIndexRoute
  '/klb-petani/cari-petani': typeof BackofficeKlbPetaniCariPetaniIndexRoute
  '/klb-petani/gapoktan': typeof BackofficeKlbPetaniGapoktanIndexRoute
  '/klb-petani/kep': typeof BackofficeKlbPetaniKepIndexRoute
  '/klb-petani/petani': typeof BackofficeKlbPetaniPetaniIndexRoute
  '/klb-petani/poktan': typeof BackofficeKlbPetaniPoktanIndexRoute
  '/ktg-penyuluh/apbd': typeof BackofficeKtgPenyuluhApbdIndexRoute
  '/ktg-penyuluh/apbn': typeof BackofficeKtgPenyuluhApbnIndexRoute
  '/ktg-penyuluh/pindah-domisili': typeof BackofficeKtgPenyuluhPindahDomisiliIndexRoute
  '/ktg-penyuluh/pns-pppk': typeof BackofficeKtgPenyuluhPnsPppkIndexRoute
  '/ktg-penyuluh/swadaya': typeof BackofficeKtgPenyuluhSwadayaIndexRoute
  '/ktg-penyuluh/swasta': typeof BackofficeKtgPenyuluhSwastaIndexRoute
  '/user/admin': typeof BackofficeUserAdminIndexRoute
  '/user/bpp': typeof BackofficeUserBppIndexRoute
  '/user/kabupaten': typeof BackofficeUserKabupatenIndexRoute
  '/user/provinsi': typeof BackofficeUserProvinsiIndexRoute
  '/verification-data/$verificationId': typeof BackofficeVerificationDataVerificationIdIndexRoute
  '/guest/extensions-institutions': typeof GuestGuestExtensionsInstitutionsIndexRoute
  '/report/pemetaan-wilker/$provinsiId': typeof ReportPemetaanWilkerProvinsiIdIndexRoute
  '/klb-penyuluh/desa/$penyuluhId/edit': typeof BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute
  '/klb-penyuluh/kecamatan/$bppId/edit': typeof BackofficeKlbPenyuluhKecamatanBppIdEditRoute
  '/klb-penyuluh/kotakab/$kotakabId/edit': typeof BackofficeKlbPenyuluhKotakabKotakabIdEditRoute
  '/klb-petani/gapoktan/$gapoktanId/edit': typeof BackofficeKlbPetaniGapoktanGapoktanIdEditRoute
  '/klb-petani/petani/$petaniId/edit': typeof BackofficeKlbPetaniPetaniPetaniIdEditRoute
  '/klb-petani/poktan/$poktanId/edit': typeof BackofficeKlbPetaniPoktanPoktanIdEditRoute
  '/user/admin/$adminId/edit': typeof BackofficeUserAdminAdminIdEditRoute
  '/user/bpp/$adminId/edit': typeof BackofficeUserBppAdminIdEditRoute
  '/user/kabupaten/$adminId/edit': typeof BackofficeUserKabupatenAdminIdEditRoute
  '/user/provinsi/$adminId/edit': typeof BackofficeUserProvinsiAdminIdEditRoute
  '/guest/extensions-institutions/bpp/$id': typeof GuestGuestExtensionsInstitutionsBppIdRoute
  '/guest/extensions-institutions/city/$id': typeof GuestGuestExtensionsInstitutionsCityIdRoute
  '/guest/extensions-institutions/posluhdes/$id': typeof GuestGuestExtensionsInstitutionsPosluhdesIdRoute
  '/guest/extensions-institutions/province/$id': typeof GuestGuestExtensionsInstitutionsProvinceIdRoute
  '/edit-penyuluh/submission/$verificationId': typeof BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute
  '/klb-penyuluh/kecamatan/$bppId': typeof BackofficeKlbPenyuluhKecamatanBppIdIndexRoute
  '/klb-penyuluh/kotakab/$kotakabId': typeof BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute
  '/klb-penyuluh/provinsi/$provinsiId': typeof BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute
  '/klb-penyuluh/provinsi/create': typeof BackofficeKlbPenyuluhProvinsiCreateIndexRoute
  '/klb-penyuluh/pusat/$pusatId': typeof BackofficeKlbPenyuluhPusatPusatIdIndexRoute
  '/klb-penyuluh/pusat/create': typeof BackofficeKlbPenyuluhPusatCreateIndexRoute
  '/klb-petani/cari-petani/$cariPetaniId': typeof BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute
  '/klb-petani/gapoktan/$gapoktanId': typeof BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute
  '/klb-petani/gapoktan/create': typeof BackofficeKlbPetaniGapoktanCreateIndexRoute
  '/klb-petani/gapoktan/submission': typeof BackofficeKlbPetaniGapoktanSubmissionIndexRoute
  '/klb-petani/kep/$kepId': typeof BackofficeKlbPetaniKepKepIdIndexRoute
  '/klb-petani/kep/create': typeof BackofficeKlbPetaniKepCreateIndexRoute
  '/klb-petani/kep/submission': typeof BackofficeKlbPetaniKepSubmissionIndexRoute
  '/klb-petani/petani/$petaniId': typeof BackofficeKlbPetaniPetaniPetaniIdIndexRoute
  '/klb-petani/petani/create': typeof BackofficeKlbPetaniPetaniCreateIndexRoute
  '/klb-petani/petani/submission': typeof BackofficeKlbPetaniPetaniSubmissionIndexRoute
  '/klb-petani/poktan/$poktanId': typeof BackofficeKlbPetaniPoktanPoktanIdIndexRoute
  '/klb-petani/poktan/create': typeof BackofficeKlbPetaniPoktanCreateIndexRoute
  '/klb-petani/poktan/submission': typeof BackofficeKlbPetaniPoktanSubmissionIndexRoute
  '/ktg-penyuluh/apbd/$apbdId': typeof BackofficeKtgPenyuluhApbdApbdIdIndexRoute
  '/ktg-penyuluh/apbd/create': typeof BackofficeKtgPenyuluhApbdCreateIndexRoute
  '/ktg-penyuluh/apbn/$apbnId': typeof BackofficeKtgPenyuluhApbnApbnIdIndexRoute
  '/ktg-penyuluh/apbn/create': typeof BackofficeKtgPenyuluhApbnCreateIndexRoute
  '/ktg-penyuluh/pns-pppk/$pnsPppkId': typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute
  '/ktg-penyuluh/pns-pppk/create': typeof BackofficeKtgPenyuluhPnsPppkCreateIndexRoute
  '/ktg-penyuluh/swadaya/$swadayaId': typeof BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute
  '/ktg-penyuluh/swadaya/create': typeof BackofficeKtgPenyuluhSwadayaCreateIndexRoute
  '/ktg-penyuluh/swasta/$swastaId': typeof BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute
  '/ktg-penyuluh/swasta/create': typeof BackofficeKtgPenyuluhSwastaCreateIndexRoute
  '/report/pemetaan-wilker/$provinsiId/$kotaId': typeof ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute
  '/klb-penyuluh/provinsi/$provinsiId/edit': typeof BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute
  '/klb-penyuluh/pusat/$pusatId/edit': typeof BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute
  '/klb-petani/gapoktan/submission/$verificationId': typeof BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute
  '/klb-petani/kep/$kepId/edit': typeof BackofficeKlbPetaniKepKepIdEditIndexRoute
  '/klb-petani/kep/submission/$verificationId': typeof BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute
  '/klb-petani/petani/submission/$verificationId': typeof BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute
  '/klb-petani/poktan/submission/$verificationId': typeof BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute
  '/ktg-penyuluh/apbd/$apbdId/edit': typeof BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute
  '/ktg-penyuluh/apbn/$apbnId/edit': typeof BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute
  '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit': typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute
  '/ktg-penyuluh/swadaya/$swadayaId/edit': typeof BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute
  '/ktg-penyuluh/swasta/$swastaId/edit': typeof BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute
  '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit': typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute
  '/klb-petani/petani/$petaniId/lahan/submission': typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute
  '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId': typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute
  '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission': typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute
  '/klb-petani/petani/$petaniId/lahan/submission/$verificationId': typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute
  '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId': typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/_backoffice': typeof BackofficeRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/report': typeof ReportRouteWithChildren
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/_guest/guest/ktg-worker-list': typeof GuestGuestKtgWorkerListRoute
  '/_guest/guest/list-gapoktan': typeof GuestGuestListGapoktanRoute
  '/_guest/guest/list-kep': typeof GuestGuestListKepRoute
  '/_guest/guest/list-poktan': typeof GuestGuestListPoktanRoute
  '/_guest/guest/list-poktan-member': typeof GuestGuestListPoktanMemberRoute
  '/_guest/guest/recap-class-poktan': typeof GuestGuestRecapClassPoktanRoute
  '/_guest/guest/recap-classifications-bpp': typeof GuestGuestRecapClassificationsBppRoute
  '/_guest/guest/recap-extensions-institutions': typeof GuestGuestRecapExtensionsInstitutionsRoute
  '/_guest/guest/recap-extentions-worker': typeof GuestGuestRecapExtentionsWorkerRoute
  '/_guest/guest/recap-farmer-institutions': typeof GuestGuestRecapFarmerInstitutionsRoute
  '/_guest/guest/recap-poktan': typeof GuestGuestRecapPoktanRoute
  '/_guest/guest/recap-shape-kep': typeof GuestGuestRecapShapeKepRoute
  '/oauth/simluhtan/callback': typeof OauthSimluhtanCallbackRoute
  '/_backoffice/about/': typeof BackofficeAboutIndexRoute
  '/_backoffice/dashboard/': typeof BackofficeDashboardIndexRoute
  '/_backoffice/edit-penyuluh/': typeof BackofficeEditPenyuluhIndexRoute
  '/_backoffice/klb-petani/': typeof BackofficeKlbPetaniIndexRoute
  '/_backoffice/profile/': typeof BackofficeProfileIndexRoute
  '/_backoffice/user/': typeof BackofficeUserIndexRoute
  '/_backoffice/verification-data/': typeof BackofficeVerificationDataIndexRoute
  '/_backoffice/verification-wilker-penyuluh/': typeof BackofficeVerificationWilkerPenyuluhIndexRoute
  '/_guest/guest/': typeof GuestGuestIndexRoute
  '/report/pemetaan-wilker/': typeof ReportPemetaanWilkerIndexRoute
  '/_backoffice/klb-penyuluh/desa/create': typeof BackofficeKlbPenyuluhDesaCreateRoute
  '/_backoffice/klb-penyuluh/kecamatan/create': typeof BackofficeKlbPenyuluhKecamatanCreateRoute
  '/_backoffice/klb-penyuluh/kotakab/create': typeof BackofficeKlbPenyuluhKotakabCreateRoute
  '/_backoffice/user/admin/create': typeof BackofficeUserAdminCreateRoute
  '/_backoffice/user/bpp/create': typeof BackofficeUserBppCreateRoute
  '/_backoffice/user/kabupaten/create': typeof BackofficeUserKabupatenCreateRoute
  '/_backoffice/user/provinsi/create': typeof BackofficeUserProvinsiCreateRoute
  '/_guest/guest/search/farmer-poktan-members': typeof GuestGuestSearchFarmerPoktanMembersRoute
  '/_guest/guest/search/klb-farmers': typeof GuestGuestSearchKlbFarmersRoute
  '/_guest/guest/search/ktg-extensions-institutions': typeof GuestGuestSearchKtgExtensionsInstitutionsRoute
  '/_backoffice/about/create/': typeof BackofficeAboutCreateIndexRoute
  '/_backoffice/edit-penyuluh/submission/': typeof BackofficeEditPenyuluhSubmissionIndexRoute
  '/_backoffice/klb-penyuluh/desa/': typeof BackofficeKlbPenyuluhDesaIndexRoute
  '/_backoffice/klb-penyuluh/kecamatan/': typeof BackofficeKlbPenyuluhKecamatanIndexRoute
  '/_backoffice/klb-penyuluh/kotakab/': typeof BackofficeKlbPenyuluhKotakabIndexRoute
  '/_backoffice/klb-penyuluh/provinsi/': typeof BackofficeKlbPenyuluhProvinsiIndexRoute
  '/_backoffice/klb-penyuluh/pusat/': typeof BackofficeKlbPenyuluhPusatIndexRoute
  '/_backoffice/klb-petani/cari-petani/': typeof BackofficeKlbPetaniCariPetaniIndexRoute
  '/_backoffice/klb-petani/gapoktan/': typeof BackofficeKlbPetaniGapoktanIndexRoute
  '/_backoffice/klb-petani/kep/': typeof BackofficeKlbPetaniKepIndexRoute
  '/_backoffice/klb-petani/petani/': typeof BackofficeKlbPetaniPetaniIndexRoute
  '/_backoffice/klb-petani/poktan/': typeof BackofficeKlbPetaniPoktanIndexRoute
  '/_backoffice/ktg-penyuluh/apbd/': typeof BackofficeKtgPenyuluhApbdIndexRoute
  '/_backoffice/ktg-penyuluh/apbn/': typeof BackofficeKtgPenyuluhApbnIndexRoute
  '/_backoffice/ktg-penyuluh/pindah-domisili/': typeof BackofficeKtgPenyuluhPindahDomisiliIndexRoute
  '/_backoffice/ktg-penyuluh/pns-pppk/': typeof BackofficeKtgPenyuluhPnsPppkIndexRoute
  '/_backoffice/ktg-penyuluh/swadaya/': typeof BackofficeKtgPenyuluhSwadayaIndexRoute
  '/_backoffice/ktg-penyuluh/swasta/': typeof BackofficeKtgPenyuluhSwastaIndexRoute
  '/_backoffice/user/admin/': typeof BackofficeUserAdminIndexRoute
  '/_backoffice/user/bpp/': typeof BackofficeUserBppIndexRoute
  '/_backoffice/user/kabupaten/': typeof BackofficeUserKabupatenIndexRoute
  '/_backoffice/user/provinsi/': typeof BackofficeUserProvinsiIndexRoute
  '/_backoffice/verification-data/$verificationId/': typeof BackofficeVerificationDataVerificationIdIndexRoute
  '/_guest/guest/extensions-institutions/': typeof GuestGuestExtensionsInstitutionsIndexRoute
  '/report/pemetaan-wilker/$provinsiId/': typeof ReportPemetaanWilkerProvinsiIdIndexRoute
  '/_backoffice/klb-penyuluh/desa/$penyuluhId/edit': typeof BackofficeKlbPenyuluhDesaPenyuluhIdEditRoute
  '/_backoffice/klb-penyuluh/kecamatan/$bppId/edit': typeof BackofficeKlbPenyuluhKecamatanBppIdEditRoute
  '/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit': typeof BackofficeKlbPenyuluhKotakabKotakabIdEditRoute
  '/_backoffice/klb-petani/gapoktan/$gapoktanId/edit': typeof BackofficeKlbPetaniGapoktanGapoktanIdEditRoute
  '/_backoffice/klb-petani/petani/$petaniId/edit': typeof BackofficeKlbPetaniPetaniPetaniIdEditRoute
  '/_backoffice/klb-petani/poktan/$poktanId/edit': typeof BackofficeKlbPetaniPoktanPoktanIdEditRoute
  '/_backoffice/user/admin/$adminId/edit': typeof BackofficeUserAdminAdminIdEditRoute
  '/_backoffice/user/bpp/$adminId/edit': typeof BackofficeUserBppAdminIdEditRoute
  '/_backoffice/user/kabupaten/$adminId/edit': typeof BackofficeUserKabupatenAdminIdEditRoute
  '/_backoffice/user/provinsi/$adminId/edit': typeof BackofficeUserProvinsiAdminIdEditRoute
  '/_guest/guest/extensions-institutions/bpp/$id': typeof GuestGuestExtensionsInstitutionsBppIdRoute
  '/_guest/guest/extensions-institutions/city/$id': typeof GuestGuestExtensionsInstitutionsCityIdRoute
  '/_guest/guest/extensions-institutions/posluhdes/$id': typeof GuestGuestExtensionsInstitutionsPosluhdesIdRoute
  '/_guest/guest/extensions-institutions/province/$id': typeof GuestGuestExtensionsInstitutionsProvinceIdRoute
  '/_backoffice/edit-penyuluh/submission/$verificationId/': typeof BackofficeEditPenyuluhSubmissionVerificationIdIndexRoute
  '/_backoffice/klb-penyuluh/kecamatan/$bppId/': typeof BackofficeKlbPenyuluhKecamatanBppIdIndexRoute
  '/_backoffice/klb-penyuluh/kotakab/$kotakabId/': typeof BackofficeKlbPenyuluhKotakabKotakabIdIndexRoute
  '/_backoffice/klb-penyuluh/provinsi/$provinsiId/': typeof BackofficeKlbPenyuluhProvinsiProvinsiIdIndexRoute
  '/_backoffice/klb-penyuluh/provinsi/create/': typeof BackofficeKlbPenyuluhProvinsiCreateIndexRoute
  '/_backoffice/klb-penyuluh/pusat/$pusatId/': typeof BackofficeKlbPenyuluhPusatPusatIdIndexRoute
  '/_backoffice/klb-penyuluh/pusat/create/': typeof BackofficeKlbPenyuluhPusatCreateIndexRoute
  '/_backoffice/klb-petani/cari-petani/$cariPetaniId/': typeof BackofficeKlbPetaniCariPetaniCariPetaniIdIndexRoute
  '/_backoffice/klb-petani/gapoktan/$gapoktanId/': typeof BackofficeKlbPetaniGapoktanGapoktanIdIndexRoute
  '/_backoffice/klb-petani/gapoktan/create/': typeof BackofficeKlbPetaniGapoktanCreateIndexRoute
  '/_backoffice/klb-petani/gapoktan/submission/': typeof BackofficeKlbPetaniGapoktanSubmissionIndexRoute
  '/_backoffice/klb-petani/kep/$kepId/': typeof BackofficeKlbPetaniKepKepIdIndexRoute
  '/_backoffice/klb-petani/kep/create/': typeof BackofficeKlbPetaniKepCreateIndexRoute
  '/_backoffice/klb-petani/kep/submission/': typeof BackofficeKlbPetaniKepSubmissionIndexRoute
  '/_backoffice/klb-petani/petani/$petaniId/': typeof BackofficeKlbPetaniPetaniPetaniIdIndexRoute
  '/_backoffice/klb-petani/petani/create/': typeof BackofficeKlbPetaniPetaniCreateIndexRoute
  '/_backoffice/klb-petani/petani/submission/': typeof BackofficeKlbPetaniPetaniSubmissionIndexRoute
  '/_backoffice/klb-petani/poktan/$poktanId/': typeof BackofficeKlbPetaniPoktanPoktanIdIndexRoute
  '/_backoffice/klb-petani/poktan/create/': typeof BackofficeKlbPetaniPoktanCreateIndexRoute
  '/_backoffice/klb-petani/poktan/submission/': typeof BackofficeKlbPetaniPoktanSubmissionIndexRoute
  '/_backoffice/ktg-penyuluh/apbd/$apbdId/': typeof BackofficeKtgPenyuluhApbdApbdIdIndexRoute
  '/_backoffice/ktg-penyuluh/apbd/create/': typeof BackofficeKtgPenyuluhApbdCreateIndexRoute
  '/_backoffice/ktg-penyuluh/apbn/$apbnId/': typeof BackofficeKtgPenyuluhApbnApbnIdIndexRoute
  '/_backoffice/ktg-penyuluh/apbn/create/': typeof BackofficeKtgPenyuluhApbnCreateIndexRoute
  '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/': typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdIndexRoute
  '/_backoffice/ktg-penyuluh/pns-pppk/create/': typeof BackofficeKtgPenyuluhPnsPppkCreateIndexRoute
  '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/': typeof BackofficeKtgPenyuluhSwadayaSwadayaIdIndexRoute
  '/_backoffice/ktg-penyuluh/swadaya/create/': typeof BackofficeKtgPenyuluhSwadayaCreateIndexRoute
  '/_backoffice/ktg-penyuluh/swasta/$swastaId/': typeof BackofficeKtgPenyuluhSwastaSwastaIdIndexRoute
  '/_backoffice/ktg-penyuluh/swasta/create/': typeof BackofficeKtgPenyuluhSwastaCreateIndexRoute
  '/report/pemetaan-wilker/$provinsiId/$kotaId/': typeof ReportPemetaanWilkerProvinsiIdKotaIdIndexRoute
  '/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/': typeof BackofficeKlbPenyuluhProvinsiProvinsiIdEditIndexRoute
  '/_backoffice/klb-penyuluh/pusat/$pusatId/edit/': typeof BackofficeKlbPenyuluhPusatPusatIdEditIndexRoute
  '/_backoffice/klb-petani/gapoktan/submission/$verificationId/': typeof BackofficeKlbPetaniGapoktanSubmissionVerificationIdIndexRoute
  '/_backoffice/klb-petani/kep/$kepId/edit/': typeof BackofficeKlbPetaniKepKepIdEditIndexRoute
  '/_backoffice/klb-petani/kep/submission/$verificationId/': typeof BackofficeKlbPetaniKepSubmissionVerificationIdIndexRoute
  '/_backoffice/klb-petani/petani/submission/$verificationId/': typeof BackofficeKlbPetaniPetaniSubmissionVerificationIdIndexRoute
  '/_backoffice/klb-petani/poktan/submission/$verificationId/': typeof BackofficeKlbPetaniPoktanSubmissionVerificationIdIndexRoute
  '/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/': typeof BackofficeKtgPenyuluhApbdApbdIdEditIndexRoute
  '/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/': typeof BackofficeKtgPenyuluhApbnApbnIdEditIndexRoute
  '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/': typeof BackofficeKtgPenyuluhPnsPppkPnsPppkIdEditIndexRoute
  '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/': typeof BackofficeKtgPenyuluhSwadayaSwadayaIdEditIndexRoute
  '/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/': typeof BackofficeKtgPenyuluhSwastaSwastaIdEditIndexRoute
  '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit': typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdEditRoute
  '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/': typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionIndexRoute
  '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/': typeof BackofficeKlbPetaniPoktanPoktanIdAnggotaAnggotaPoktanIdIndexRoute
  '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/': typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionIndexRoute
  '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/': typeof BackofficeKlbPetaniPetaniPetaniIdLahanSubmissionVerificationIdIndexRoute
  '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/': typeof BackofficeKlbPetaniPoktanPoktanIdKelasKemampuanSubmissionVerificationIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | ''
    | '/report'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/guest/ktg-worker-list'
    | '/guest/list-gapoktan'
    | '/guest/list-kep'
    | '/guest/list-poktan'
    | '/guest/list-poktan-member'
    | '/guest/recap-class-poktan'
    | '/guest/recap-classifications-bpp'
    | '/guest/recap-extensions-institutions'
    | '/guest/recap-extentions-worker'
    | '/guest/recap-farmer-institutions'
    | '/guest/recap-poktan'
    | '/guest/recap-shape-kep'
    | '/oauth/simluhtan/callback'
    | '/about'
    | '/dashboard'
    | '/edit-penyuluh'
    | '/klb-petani'
    | '/profile'
    | '/user'
    | '/verification-data'
    | '/verification-wilker-penyuluh'
    | '/guest'
    | '/report/pemetaan-wilker'
    | '/klb-penyuluh/desa/create'
    | '/klb-penyuluh/kecamatan/create'
    | '/klb-penyuluh/kotakab/create'
    | '/user/admin/create'
    | '/user/bpp/create'
    | '/user/kabupaten/create'
    | '/user/provinsi/create'
    | '/guest/search/farmer-poktan-members'
    | '/guest/search/klb-farmers'
    | '/guest/search/ktg-extensions-institutions'
    | '/about/create'
    | '/edit-penyuluh/submission'
    | '/klb-penyuluh/desa'
    | '/klb-penyuluh/kecamatan'
    | '/klb-penyuluh/kotakab'
    | '/klb-penyuluh/provinsi'
    | '/klb-penyuluh/pusat'
    | '/klb-petani/cari-petani'
    | '/klb-petani/gapoktan'
    | '/klb-petani/kep'
    | '/klb-petani/petani'
    | '/klb-petani/poktan'
    | '/ktg-penyuluh/apbd'
    | '/ktg-penyuluh/apbn'
    | '/ktg-penyuluh/pindah-domisili'
    | '/ktg-penyuluh/pns-pppk'
    | '/ktg-penyuluh/swadaya'
    | '/ktg-penyuluh/swasta'
    | '/user/admin'
    | '/user/bpp'
    | '/user/kabupaten'
    | '/user/provinsi'
    | '/verification-data/$verificationId'
    | '/guest/extensions-institutions'
    | '/report/pemetaan-wilker/$provinsiId'
    | '/klb-penyuluh/desa/$penyuluhId/edit'
    | '/klb-penyuluh/kecamatan/$bppId/edit'
    | '/klb-penyuluh/kotakab/$kotakabId/edit'
    | '/klb-petani/gapoktan/$gapoktanId/edit'
    | '/klb-petani/petani/$petaniId/edit'
    | '/klb-petani/poktan/$poktanId/edit'
    | '/user/admin/$adminId/edit'
    | '/user/bpp/$adminId/edit'
    | '/user/kabupaten/$adminId/edit'
    | '/user/provinsi/$adminId/edit'
    | '/guest/extensions-institutions/bpp/$id'
    | '/guest/extensions-institutions/city/$id'
    | '/guest/extensions-institutions/posluhdes/$id'
    | '/guest/extensions-institutions/province/$id'
    | '/edit-penyuluh/submission/$verificationId'
    | '/klb-penyuluh/kecamatan/$bppId'
    | '/klb-penyuluh/kotakab/$kotakabId'
    | '/klb-penyuluh/provinsi/$provinsiId'
    | '/klb-penyuluh/provinsi/create'
    | '/klb-penyuluh/pusat/$pusatId'
    | '/klb-penyuluh/pusat/create'
    | '/klb-petani/cari-petani/$cariPetaniId'
    | '/klb-petani/gapoktan/$gapoktanId'
    | '/klb-petani/gapoktan/create'
    | '/klb-petani/gapoktan/submission'
    | '/klb-petani/kep/$kepId'
    | '/klb-petani/kep/create'
    | '/klb-petani/kep/submission'
    | '/klb-petani/petani/$petaniId'
    | '/klb-petani/petani/create'
    | '/klb-petani/petani/submission'
    | '/klb-petani/poktan/$poktanId'
    | '/klb-petani/poktan/create'
    | '/klb-petani/poktan/submission'
    | '/ktg-penyuluh/apbd/$apbdId'
    | '/ktg-penyuluh/apbd/create'
    | '/ktg-penyuluh/apbn/$apbnId'
    | '/ktg-penyuluh/apbn/create'
    | '/ktg-penyuluh/pns-pppk/$pnsPppkId'
    | '/ktg-penyuluh/pns-pppk/create'
    | '/ktg-penyuluh/swadaya/$swadayaId'
    | '/ktg-penyuluh/swadaya/create'
    | '/ktg-penyuluh/swasta/$swastaId'
    | '/ktg-penyuluh/swasta/create'
    | '/report/pemetaan-wilker/$provinsiId/$kotaId'
    | '/klb-penyuluh/provinsi/$provinsiId/edit'
    | '/klb-penyuluh/pusat/$pusatId/edit'
    | '/klb-petani/gapoktan/submission/$verificationId'
    | '/klb-petani/kep/$kepId/edit'
    | '/klb-petani/kep/submission/$verificationId'
    | '/klb-petani/petani/submission/$verificationId'
    | '/klb-petani/poktan/submission/$verificationId'
    | '/ktg-penyuluh/apbd/$apbdId/edit'
    | '/ktg-penyuluh/apbn/$apbnId/edit'
    | '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit'
    | '/ktg-penyuluh/swadaya/$swadayaId/edit'
    | '/ktg-penyuluh/swasta/$swastaId/edit'
    | '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
    | '/klb-petani/petani/$petaniId/lahan/submission'
    | '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId'
    | '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission'
    | '/klb-petani/petani/$petaniId/lahan/submission/$verificationId'
    | '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | ''
    | '/report'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/guest/ktg-worker-list'
    | '/guest/list-gapoktan'
    | '/guest/list-kep'
    | '/guest/list-poktan'
    | '/guest/list-poktan-member'
    | '/guest/recap-class-poktan'
    | '/guest/recap-classifications-bpp'
    | '/guest/recap-extensions-institutions'
    | '/guest/recap-extentions-worker'
    | '/guest/recap-farmer-institutions'
    | '/guest/recap-poktan'
    | '/guest/recap-shape-kep'
    | '/oauth/simluhtan/callback'
    | '/about'
    | '/dashboard'
    | '/edit-penyuluh'
    | '/klb-petani'
    | '/profile'
    | '/user'
    | '/verification-data'
    | '/verification-wilker-penyuluh'
    | '/guest'
    | '/report/pemetaan-wilker'
    | '/klb-penyuluh/desa/create'
    | '/klb-penyuluh/kecamatan/create'
    | '/klb-penyuluh/kotakab/create'
    | '/user/admin/create'
    | '/user/bpp/create'
    | '/user/kabupaten/create'
    | '/user/provinsi/create'
    | '/guest/search/farmer-poktan-members'
    | '/guest/search/klb-farmers'
    | '/guest/search/ktg-extensions-institutions'
    | '/about/create'
    | '/edit-penyuluh/submission'
    | '/klb-penyuluh/desa'
    | '/klb-penyuluh/kecamatan'
    | '/klb-penyuluh/kotakab'
    | '/klb-penyuluh/provinsi'
    | '/klb-penyuluh/pusat'
    | '/klb-petani/cari-petani'
    | '/klb-petani/gapoktan'
    | '/klb-petani/kep'
    | '/klb-petani/petani'
    | '/klb-petani/poktan'
    | '/ktg-penyuluh/apbd'
    | '/ktg-penyuluh/apbn'
    | '/ktg-penyuluh/pindah-domisili'
    | '/ktg-penyuluh/pns-pppk'
    | '/ktg-penyuluh/swadaya'
    | '/ktg-penyuluh/swasta'
    | '/user/admin'
    | '/user/bpp'
    | '/user/kabupaten'
    | '/user/provinsi'
    | '/verification-data/$verificationId'
    | '/guest/extensions-institutions'
    | '/report/pemetaan-wilker/$provinsiId'
    | '/klb-penyuluh/desa/$penyuluhId/edit'
    | '/klb-penyuluh/kecamatan/$bppId/edit'
    | '/klb-penyuluh/kotakab/$kotakabId/edit'
    | '/klb-petani/gapoktan/$gapoktanId/edit'
    | '/klb-petani/petani/$petaniId/edit'
    | '/klb-petani/poktan/$poktanId/edit'
    | '/user/admin/$adminId/edit'
    | '/user/bpp/$adminId/edit'
    | '/user/kabupaten/$adminId/edit'
    | '/user/provinsi/$adminId/edit'
    | '/guest/extensions-institutions/bpp/$id'
    | '/guest/extensions-institutions/city/$id'
    | '/guest/extensions-institutions/posluhdes/$id'
    | '/guest/extensions-institutions/province/$id'
    | '/edit-penyuluh/submission/$verificationId'
    | '/klb-penyuluh/kecamatan/$bppId'
    | '/klb-penyuluh/kotakab/$kotakabId'
    | '/klb-penyuluh/provinsi/$provinsiId'
    | '/klb-penyuluh/provinsi/create'
    | '/klb-penyuluh/pusat/$pusatId'
    | '/klb-penyuluh/pusat/create'
    | '/klb-petani/cari-petani/$cariPetaniId'
    | '/klb-petani/gapoktan/$gapoktanId'
    | '/klb-petani/gapoktan/create'
    | '/klb-petani/gapoktan/submission'
    | '/klb-petani/kep/$kepId'
    | '/klb-petani/kep/create'
    | '/klb-petani/kep/submission'
    | '/klb-petani/petani/$petaniId'
    | '/klb-petani/petani/create'
    | '/klb-petani/petani/submission'
    | '/klb-petani/poktan/$poktanId'
    | '/klb-petani/poktan/create'
    | '/klb-petani/poktan/submission'
    | '/ktg-penyuluh/apbd/$apbdId'
    | '/ktg-penyuluh/apbd/create'
    | '/ktg-penyuluh/apbn/$apbnId'
    | '/ktg-penyuluh/apbn/create'
    | '/ktg-penyuluh/pns-pppk/$pnsPppkId'
    | '/ktg-penyuluh/pns-pppk/create'
    | '/ktg-penyuluh/swadaya/$swadayaId'
    | '/ktg-penyuluh/swadaya/create'
    | '/ktg-penyuluh/swasta/$swastaId'
    | '/ktg-penyuluh/swasta/create'
    | '/report/pemetaan-wilker/$provinsiId/$kotaId'
    | '/klb-penyuluh/provinsi/$provinsiId/edit'
    | '/klb-penyuluh/pusat/$pusatId/edit'
    | '/klb-petani/gapoktan/submission/$verificationId'
    | '/klb-petani/kep/$kepId/edit'
    | '/klb-petani/kep/submission/$verificationId'
    | '/klb-petani/petani/submission/$verificationId'
    | '/klb-petani/poktan/submission/$verificationId'
    | '/ktg-penyuluh/apbd/$apbdId/edit'
    | '/ktg-penyuluh/apbn/$apbnId/edit'
    | '/ktg-penyuluh/pns-pppk/$pnsPppkId/edit'
    | '/ktg-penyuluh/swadaya/$swadayaId/edit'
    | '/ktg-penyuluh/swasta/$swastaId/edit'
    | '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
    | '/klb-petani/petani/$petaniId/lahan/submission'
    | '/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId'
    | '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission'
    | '/klb-petani/petani/$petaniId/lahan/submission/$verificationId'
    | '/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/_backoffice'
    | '/_guest'
    | '/report'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/_guest/guest/ktg-worker-list'
    | '/_guest/guest/list-gapoktan'
    | '/_guest/guest/list-kep'
    | '/_guest/guest/list-poktan'
    | '/_guest/guest/list-poktan-member'
    | '/_guest/guest/recap-class-poktan'
    | '/_guest/guest/recap-classifications-bpp'
    | '/_guest/guest/recap-extensions-institutions'
    | '/_guest/guest/recap-extentions-worker'
    | '/_guest/guest/recap-farmer-institutions'
    | '/_guest/guest/recap-poktan'
    | '/_guest/guest/recap-shape-kep'
    | '/oauth/simluhtan/callback'
    | '/_backoffice/about/'
    | '/_backoffice/dashboard/'
    | '/_backoffice/edit-penyuluh/'
    | '/_backoffice/klb-petani/'
    | '/_backoffice/profile/'
    | '/_backoffice/user/'
    | '/_backoffice/verification-data/'
    | '/_backoffice/verification-wilker-penyuluh/'
    | '/_guest/guest/'
    | '/report/pemetaan-wilker/'
    | '/_backoffice/klb-penyuluh/desa/create'
    | '/_backoffice/klb-penyuluh/kecamatan/create'
    | '/_backoffice/klb-penyuluh/kotakab/create'
    | '/_backoffice/user/admin/create'
    | '/_backoffice/user/bpp/create'
    | '/_backoffice/user/kabupaten/create'
    | '/_backoffice/user/provinsi/create'
    | '/_guest/guest/search/farmer-poktan-members'
    | '/_guest/guest/search/klb-farmers'
    | '/_guest/guest/search/ktg-extensions-institutions'
    | '/_backoffice/about/create/'
    | '/_backoffice/edit-penyuluh/submission/'
    | '/_backoffice/klb-penyuluh/desa/'
    | '/_backoffice/klb-penyuluh/kecamatan/'
    | '/_backoffice/klb-penyuluh/kotakab/'
    | '/_backoffice/klb-penyuluh/provinsi/'
    | '/_backoffice/klb-penyuluh/pusat/'
    | '/_backoffice/klb-petani/cari-petani/'
    | '/_backoffice/klb-petani/gapoktan/'
    | '/_backoffice/klb-petani/kep/'
    | '/_backoffice/klb-petani/petani/'
    | '/_backoffice/klb-petani/poktan/'
    | '/_backoffice/ktg-penyuluh/apbd/'
    | '/_backoffice/ktg-penyuluh/apbn/'
    | '/_backoffice/ktg-penyuluh/pindah-domisili/'
    | '/_backoffice/ktg-penyuluh/pns-pppk/'
    | '/_backoffice/ktg-penyuluh/swadaya/'
    | '/_backoffice/ktg-penyuluh/swasta/'
    | '/_backoffice/user/admin/'
    | '/_backoffice/user/bpp/'
    | '/_backoffice/user/kabupaten/'
    | '/_backoffice/user/provinsi/'
    | '/_backoffice/verification-data/$verificationId/'
    | '/_guest/guest/extensions-institutions/'
    | '/report/pemetaan-wilker/$provinsiId/'
    | '/_backoffice/klb-penyuluh/desa/$penyuluhId/edit'
    | '/_backoffice/klb-penyuluh/kecamatan/$bppId/edit'
    | '/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit'
    | '/_backoffice/klb-petani/gapoktan/$gapoktanId/edit'
    | '/_backoffice/klb-petani/petani/$petaniId/edit'
    | '/_backoffice/klb-petani/poktan/$poktanId/edit'
    | '/_backoffice/user/admin/$adminId/edit'
    | '/_backoffice/user/bpp/$adminId/edit'
    | '/_backoffice/user/kabupaten/$adminId/edit'
    | '/_backoffice/user/provinsi/$adminId/edit'
    | '/_guest/guest/extensions-institutions/bpp/$id'
    | '/_guest/guest/extensions-institutions/city/$id'
    | '/_guest/guest/extensions-institutions/posluhdes/$id'
    | '/_guest/guest/extensions-institutions/province/$id'
    | '/_backoffice/edit-penyuluh/submission/$verificationId/'
    | '/_backoffice/klb-penyuluh/kecamatan/$bppId/'
    | '/_backoffice/klb-penyuluh/kotakab/$kotakabId/'
    | '/_backoffice/klb-penyuluh/provinsi/$provinsiId/'
    | '/_backoffice/klb-penyuluh/provinsi/create/'
    | '/_backoffice/klb-penyuluh/pusat/$pusatId/'
    | '/_backoffice/klb-penyuluh/pusat/create/'
    | '/_backoffice/klb-petani/cari-petani/$cariPetaniId/'
    | '/_backoffice/klb-petani/gapoktan/$gapoktanId/'
    | '/_backoffice/klb-petani/gapoktan/create/'
    | '/_backoffice/klb-petani/gapoktan/submission/'
    | '/_backoffice/klb-petani/kep/$kepId/'
    | '/_backoffice/klb-petani/kep/create/'
    | '/_backoffice/klb-petani/kep/submission/'
    | '/_backoffice/klb-petani/petani/$petaniId/'
    | '/_backoffice/klb-petani/petani/create/'
    | '/_backoffice/klb-petani/petani/submission/'
    | '/_backoffice/klb-petani/poktan/$poktanId/'
    | '/_backoffice/klb-petani/poktan/create/'
    | '/_backoffice/klb-petani/poktan/submission/'
    | '/_backoffice/ktg-penyuluh/apbd/$apbdId/'
    | '/_backoffice/ktg-penyuluh/apbd/create/'
    | '/_backoffice/ktg-penyuluh/apbn/$apbnId/'
    | '/_backoffice/ktg-penyuluh/apbn/create/'
    | '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/'
    | '/_backoffice/ktg-penyuluh/pns-pppk/create/'
    | '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/'
    | '/_backoffice/ktg-penyuluh/swadaya/create/'
    | '/_backoffice/ktg-penyuluh/swasta/$swastaId/'
    | '/_backoffice/ktg-penyuluh/swasta/create/'
    | '/report/pemetaan-wilker/$provinsiId/$kotaId/'
    | '/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/'
    | '/_backoffice/klb-penyuluh/pusat/$pusatId/edit/'
    | '/_backoffice/klb-petani/gapoktan/submission/$verificationId/'
    | '/_backoffice/klb-petani/kep/$kepId/edit/'
    | '/_backoffice/klb-petani/kep/submission/$verificationId/'
    | '/_backoffice/klb-petani/petani/submission/$verificationId/'
    | '/_backoffice/klb-petani/poktan/submission/$verificationId/'
    | '/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/'
    | '/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/'
    | '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/'
    | '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/'
    | '/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/'
    | '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
    | '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/'
    | '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/'
    | '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/'
    | '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/'
    | '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  BackofficeRoute: typeof BackofficeRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  ReportRoute: typeof ReportRouteWithChildren
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  OauthSimluhtanCallbackRoute: typeof OauthSimluhtanCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  BackofficeRoute: BackofficeRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  ReportRoute: ReportRouteWithChildren,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  OauthSimluhtanCallbackRoute: OauthSimluhtanCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/403",
        "/_backoffice",
        "/_guest",
        "/report",
        "/auth/reset-password",
        "/auth/sign-in",
        "/oauth/simluhtan/callback"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/403": {
      "filePath": "403.tsx"
    },
    "/_backoffice": {
      "filePath": "_backoffice.tsx",
      "children": [
        "/_backoffice/about/",
        "/_backoffice/dashboard/",
        "/_backoffice/edit-penyuluh/",
        "/_backoffice/klb-petani/",
        "/_backoffice/profile/",
        "/_backoffice/user/",
        "/_backoffice/verification-data/",
        "/_backoffice/verification-wilker-penyuluh/",
        "/_backoffice/klb-penyuluh/desa/create",
        "/_backoffice/klb-penyuluh/kecamatan/create",
        "/_backoffice/klb-penyuluh/kotakab/create",
        "/_backoffice/user/admin/create",
        "/_backoffice/user/bpp/create",
        "/_backoffice/user/kabupaten/create",
        "/_backoffice/user/provinsi/create",
        "/_backoffice/about/create/",
        "/_backoffice/edit-penyuluh/submission/",
        "/_backoffice/klb-penyuluh/desa/",
        "/_backoffice/klb-penyuluh/kecamatan/",
        "/_backoffice/klb-penyuluh/kotakab/",
        "/_backoffice/klb-penyuluh/provinsi/",
        "/_backoffice/klb-penyuluh/pusat/",
        "/_backoffice/klb-petani/cari-petani/",
        "/_backoffice/klb-petani/gapoktan/",
        "/_backoffice/klb-petani/kep/",
        "/_backoffice/klb-petani/petani/",
        "/_backoffice/klb-petani/poktan/",
        "/_backoffice/ktg-penyuluh/apbd/",
        "/_backoffice/ktg-penyuluh/apbn/",
        "/_backoffice/ktg-penyuluh/pindah-domisili/",
        "/_backoffice/ktg-penyuluh/pns-pppk/",
        "/_backoffice/ktg-penyuluh/swadaya/",
        "/_backoffice/ktg-penyuluh/swasta/",
        "/_backoffice/user/admin/",
        "/_backoffice/user/bpp/",
        "/_backoffice/user/kabupaten/",
        "/_backoffice/user/provinsi/",
        "/_backoffice/verification-data/$verificationId/",
        "/_backoffice/klb-penyuluh/desa/$penyuluhId/edit",
        "/_backoffice/klb-penyuluh/kecamatan/$bppId/edit",
        "/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit",
        "/_backoffice/klb-petani/gapoktan/$gapoktanId/edit",
        "/_backoffice/klb-petani/petani/$petaniId/edit",
        "/_backoffice/klb-petani/poktan/$poktanId/edit",
        "/_backoffice/user/admin/$adminId/edit",
        "/_backoffice/user/bpp/$adminId/edit",
        "/_backoffice/user/kabupaten/$adminId/edit",
        "/_backoffice/user/provinsi/$adminId/edit",
        "/_backoffice/edit-penyuluh/submission/$verificationId/",
        "/_backoffice/klb-penyuluh/kecamatan/$bppId/",
        "/_backoffice/klb-penyuluh/kotakab/$kotakabId/",
        "/_backoffice/klb-penyuluh/provinsi/$provinsiId/",
        "/_backoffice/klb-penyuluh/provinsi/create/",
        "/_backoffice/klb-penyuluh/pusat/$pusatId/",
        "/_backoffice/klb-penyuluh/pusat/create/",
        "/_backoffice/klb-petani/cari-petani/$cariPetaniId/",
        "/_backoffice/klb-petani/gapoktan/$gapoktanId/",
        "/_backoffice/klb-petani/gapoktan/create/",
        "/_backoffice/klb-petani/gapoktan/submission/",
        "/_backoffice/klb-petani/kep/$kepId/",
        "/_backoffice/klb-petani/kep/create/",
        "/_backoffice/klb-petani/kep/submission/",
        "/_backoffice/klb-petani/petani/$petaniId/",
        "/_backoffice/klb-petani/petani/create/",
        "/_backoffice/klb-petani/petani/submission/",
        "/_backoffice/klb-petani/poktan/$poktanId/",
        "/_backoffice/klb-petani/poktan/create/",
        "/_backoffice/klb-petani/poktan/submission/",
        "/_backoffice/ktg-penyuluh/apbd/$apbdId/",
        "/_backoffice/ktg-penyuluh/apbd/create/",
        "/_backoffice/ktg-penyuluh/apbn/$apbnId/",
        "/_backoffice/ktg-penyuluh/apbn/create/",
        "/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/",
        "/_backoffice/ktg-penyuluh/pns-pppk/create/",
        "/_backoffice/ktg-penyuluh/swadaya/$swadayaId/",
        "/_backoffice/ktg-penyuluh/swadaya/create/",
        "/_backoffice/ktg-penyuluh/swasta/$swastaId/",
        "/_backoffice/ktg-penyuluh/swasta/create/",
        "/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/",
        "/_backoffice/klb-penyuluh/pusat/$pusatId/edit/",
        "/_backoffice/klb-petani/gapoktan/submission/$verificationId/",
        "/_backoffice/klb-petani/kep/$kepId/edit/",
        "/_backoffice/klb-petani/kep/submission/$verificationId/",
        "/_backoffice/klb-petani/petani/submission/$verificationId/",
        "/_backoffice/klb-petani/poktan/submission/$verificationId/",
        "/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/",
        "/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/",
        "/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/",
        "/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/",
        "/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/",
        "/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit",
        "/_backoffice/klb-petani/petani/$petaniId/lahan/submission/",
        "/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/",
        "/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/",
        "/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/",
        "/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/"
      ]
    },
    "/_guest": {
      "filePath": "_guest.tsx",
      "children": [
        "/_guest/guest/ktg-worker-list",
        "/_guest/guest/list-gapoktan",
        "/_guest/guest/list-kep",
        "/_guest/guest/list-poktan",
        "/_guest/guest/list-poktan-member",
        "/_guest/guest/recap-class-poktan",
        "/_guest/guest/recap-classifications-bpp",
        "/_guest/guest/recap-extensions-institutions",
        "/_guest/guest/recap-extentions-worker",
        "/_guest/guest/recap-farmer-institutions",
        "/_guest/guest/recap-poktan",
        "/_guest/guest/recap-shape-kep",
        "/_guest/guest/",
        "/_guest/guest/search/farmer-poktan-members",
        "/_guest/guest/search/klb-farmers",
        "/_guest/guest/search/ktg-extensions-institutions",
        "/_guest/guest/extensions-institutions/",
        "/_guest/guest/extensions-institutions/bpp/$id",
        "/_guest/guest/extensions-institutions/city/$id",
        "/_guest/guest/extensions-institutions/posluhdes/$id",
        "/_guest/guest/extensions-institutions/province/$id"
      ]
    },
    "/report": {
      "filePath": "report.tsx",
      "children": [
        "/report/pemetaan-wilker/",
        "/report/pemetaan-wilker/$provinsiId/",
        "/report/pemetaan-wilker/$provinsiId/$kotaId/"
      ]
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/auth/sign-in": {
      "filePath": "auth/sign-in.tsx"
    },
    "/_guest/guest/ktg-worker-list": {
      "filePath": "_guest/guest/ktg-worker-list.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/list-gapoktan": {
      "filePath": "_guest/guest/list-gapoktan.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/list-kep": {
      "filePath": "_guest/guest/list-kep.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/list-poktan": {
      "filePath": "_guest/guest/list-poktan.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/list-poktan-member": {
      "filePath": "_guest/guest/list-poktan-member.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-class-poktan": {
      "filePath": "_guest/guest/recap-class-poktan.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-classifications-bpp": {
      "filePath": "_guest/guest/recap-classifications-bpp.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-extensions-institutions": {
      "filePath": "_guest/guest/recap-extensions-institutions.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-extentions-worker": {
      "filePath": "_guest/guest/recap-extentions-worker.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-farmer-institutions": {
      "filePath": "_guest/guest/recap-farmer-institutions.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-poktan": {
      "filePath": "_guest/guest/recap-poktan.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/recap-shape-kep": {
      "filePath": "_guest/guest/recap-shape-kep.tsx",
      "parent": "/_guest"
    },
    "/oauth/simluhtan/callback": {
      "filePath": "oauth/simluhtan/callback.tsx"
    },
    "/_backoffice/about/": {
      "filePath": "_backoffice/about/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/dashboard/": {
      "filePath": "_backoffice/dashboard/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/edit-penyuluh/": {
      "filePath": "_backoffice/edit-penyuluh/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/": {
      "filePath": "_backoffice/klb-petani/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/profile/": {
      "filePath": "_backoffice/profile/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/": {
      "filePath": "_backoffice/user/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/verification-data/": {
      "filePath": "_backoffice/verification-data/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/verification-wilker-penyuluh/": {
      "filePath": "_backoffice/verification-wilker-penyuluh/index.tsx",
      "parent": "/_backoffice"
    },
    "/_guest/guest/": {
      "filePath": "_guest/guest/index.tsx",
      "parent": "/_guest"
    },
    "/report/pemetaan-wilker/": {
      "filePath": "report/pemetaan-wilker/index.tsx",
      "parent": "/report"
    },
    "/_backoffice/klb-penyuluh/desa/create": {
      "filePath": "_backoffice/klb-penyuluh/desa/create.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kecamatan/create": {
      "filePath": "_backoffice/klb-penyuluh/kecamatan/create.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kotakab/create": {
      "filePath": "_backoffice/klb-penyuluh/kotakab/create.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/admin/create": {
      "filePath": "_backoffice/user/admin/create.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/bpp/create": {
      "filePath": "_backoffice/user/bpp/create.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/kabupaten/create": {
      "filePath": "_backoffice/user/kabupaten/create.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/provinsi/create": {
      "filePath": "_backoffice/user/provinsi/create.tsx",
      "parent": "/_backoffice"
    },
    "/_guest/guest/search/farmer-poktan-members": {
      "filePath": "_guest/guest/search/farmer-poktan-members.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/search/klb-farmers": {
      "filePath": "_guest/guest/search/klb-farmers.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/search/ktg-extensions-institutions": {
      "filePath": "_guest/guest/search/ktg-extensions-institutions.tsx",
      "parent": "/_guest"
    },
    "/_backoffice/about/create/": {
      "filePath": "_backoffice/about/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/edit-penyuluh/submission/": {
      "filePath": "_backoffice/edit-penyuluh/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/desa/": {
      "filePath": "_backoffice/klb-penyuluh/desa/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kecamatan/": {
      "filePath": "_backoffice/klb-penyuluh/kecamatan/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kotakab/": {
      "filePath": "_backoffice/klb-penyuluh/kotakab/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/provinsi/": {
      "filePath": "_backoffice/klb-penyuluh/provinsi/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/pusat/": {
      "filePath": "_backoffice/klb-penyuluh/pusat/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/cari-petani/": {
      "filePath": "_backoffice/klb-petani/cari-petani/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/gapoktan/": {
      "filePath": "_backoffice/klb-petani/gapoktan/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/kep/": {
      "filePath": "_backoffice/klb-petani/kep/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/": {
      "filePath": "_backoffice/klb-petani/petani/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/": {
      "filePath": "_backoffice/klb-petani/poktan/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbd/": {
      "filePath": "_backoffice/ktg-penyuluh/apbd/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbn/": {
      "filePath": "_backoffice/ktg-penyuluh/apbn/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/pindah-domisili/": {
      "filePath": "_backoffice/ktg-penyuluh/pindah-domisili/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/pns-pppk/": {
      "filePath": "_backoffice/ktg-penyuluh/pns-pppk/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swadaya/": {
      "filePath": "_backoffice/ktg-penyuluh/swadaya/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swasta/": {
      "filePath": "_backoffice/ktg-penyuluh/swasta/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/admin/": {
      "filePath": "_backoffice/user/admin/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/bpp/": {
      "filePath": "_backoffice/user/bpp/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/kabupaten/": {
      "filePath": "_backoffice/user/kabupaten/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/provinsi/": {
      "filePath": "_backoffice/user/provinsi/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/verification-data/$verificationId/": {
      "filePath": "_backoffice/verification-data/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_guest/guest/extensions-institutions/": {
      "filePath": "_guest/guest/extensions-institutions/index.tsx",
      "parent": "/_guest"
    },
    "/report/pemetaan-wilker/$provinsiId/": {
      "filePath": "report/pemetaan-wilker/$provinsiId/index.tsx",
      "parent": "/report"
    },
    "/_backoffice/klb-penyuluh/desa/$penyuluhId/edit": {
      "filePath": "_backoffice/klb-penyuluh/desa/$penyuluhId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kecamatan/$bppId/edit": {
      "filePath": "_backoffice/klb-penyuluh/kecamatan/$bppId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit": {
      "filePath": "_backoffice/klb-penyuluh/kotakab/$kotakabId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/gapoktan/$gapoktanId/edit": {
      "filePath": "_backoffice/klb-petani/gapoktan/$gapoktanId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/$petaniId/edit": {
      "filePath": "_backoffice/klb-petani/petani/$petaniId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/$poktanId/edit": {
      "filePath": "_backoffice/klb-petani/poktan/$poktanId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/admin/$adminId/edit": {
      "filePath": "_backoffice/user/admin/$adminId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/bpp/$adminId/edit": {
      "filePath": "_backoffice/user/bpp/$adminId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/kabupaten/$adminId/edit": {
      "filePath": "_backoffice/user/kabupaten/$adminId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/user/provinsi/$adminId/edit": {
      "filePath": "_backoffice/user/provinsi/$adminId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_guest/guest/extensions-institutions/bpp/$id": {
      "filePath": "_guest/guest/extensions-institutions/bpp/$id.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/extensions-institutions/city/$id": {
      "filePath": "_guest/guest/extensions-institutions/city/$id.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/extensions-institutions/posluhdes/$id": {
      "filePath": "_guest/guest/extensions-institutions/posluhdes/$id.tsx",
      "parent": "/_guest"
    },
    "/_guest/guest/extensions-institutions/province/$id": {
      "filePath": "_guest/guest/extensions-institutions/province/$id.tsx",
      "parent": "/_guest"
    },
    "/_backoffice/edit-penyuluh/submission/$verificationId/": {
      "filePath": "_backoffice/edit-penyuluh/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kecamatan/$bppId/": {
      "filePath": "_backoffice/klb-penyuluh/kecamatan/$bppId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/kotakab/$kotakabId/": {
      "filePath": "_backoffice/klb-penyuluh/kotakab/$kotakabId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/provinsi/$provinsiId/": {
      "filePath": "_backoffice/klb-penyuluh/provinsi/$provinsiId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/provinsi/create/": {
      "filePath": "_backoffice/klb-penyuluh/provinsi/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/pusat/$pusatId/": {
      "filePath": "_backoffice/klb-penyuluh/pusat/$pusatId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/pusat/create/": {
      "filePath": "_backoffice/klb-penyuluh/pusat/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/cari-petani/$cariPetaniId/": {
      "filePath": "_backoffice/klb-petani/cari-petani/$cariPetaniId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/gapoktan/$gapoktanId/": {
      "filePath": "_backoffice/klb-petani/gapoktan/$gapoktanId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/gapoktan/create/": {
      "filePath": "_backoffice/klb-petani/gapoktan/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/gapoktan/submission/": {
      "filePath": "_backoffice/klb-petani/gapoktan/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/kep/$kepId/": {
      "filePath": "_backoffice/klb-petani/kep/$kepId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/kep/create/": {
      "filePath": "_backoffice/klb-petani/kep/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/kep/submission/": {
      "filePath": "_backoffice/klb-petani/kep/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/$petaniId/": {
      "filePath": "_backoffice/klb-petani/petani/$petaniId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/create/": {
      "filePath": "_backoffice/klb-petani/petani/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/submission/": {
      "filePath": "_backoffice/klb-petani/petani/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/$poktanId/": {
      "filePath": "_backoffice/klb-petani/poktan/$poktanId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/create/": {
      "filePath": "_backoffice/klb-petani/poktan/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/submission/": {
      "filePath": "_backoffice/klb-petani/poktan/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbd/$apbdId/": {
      "filePath": "_backoffice/ktg-penyuluh/apbd/$apbdId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbd/create/": {
      "filePath": "_backoffice/ktg-penyuluh/apbd/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbn/$apbnId/": {
      "filePath": "_backoffice/ktg-penyuluh/apbn/$apbnId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbn/create/": {
      "filePath": "_backoffice/ktg-penyuluh/apbn/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/": {
      "filePath": "_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/pns-pppk/create/": {
      "filePath": "_backoffice/ktg-penyuluh/pns-pppk/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swadaya/$swadayaId/": {
      "filePath": "_backoffice/ktg-penyuluh/swadaya/$swadayaId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swadaya/create/": {
      "filePath": "_backoffice/ktg-penyuluh/swadaya/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swasta/$swastaId/": {
      "filePath": "_backoffice/ktg-penyuluh/swasta/$swastaId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swasta/create/": {
      "filePath": "_backoffice/ktg-penyuluh/swasta/create/index.tsx",
      "parent": "/_backoffice"
    },
    "/report/pemetaan-wilker/$provinsiId/$kotaId/": {
      "filePath": "report/pemetaan-wilker/$provinsiId/$kotaId/index.tsx",
      "parent": "/report"
    },
    "/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/": {
      "filePath": "_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-penyuluh/pusat/$pusatId/edit/": {
      "filePath": "_backoffice/klb-penyuluh/pusat/$pusatId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/gapoktan/submission/$verificationId/": {
      "filePath": "_backoffice/klb-petani/gapoktan/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/kep/$kepId/edit/": {
      "filePath": "_backoffice/klb-petani/kep/$kepId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/kep/submission/$verificationId/": {
      "filePath": "_backoffice/klb-petani/kep/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/submission/$verificationId/": {
      "filePath": "_backoffice/klb-petani/petani/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/submission/$verificationId/": {
      "filePath": "_backoffice/klb-petani/poktan/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/": {
      "filePath": "_backoffice/ktg-penyuluh/apbd/$apbdId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/": {
      "filePath": "_backoffice/ktg-penyuluh/apbn/$apbnId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/": {
      "filePath": "_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/": {
      "filePath": "_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/": {
      "filePath": "_backoffice/ktg-penyuluh/swasta/$swastaId/edit/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit": {
      "filePath": "_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/$petaniId/lahan/submission/": {
      "filePath": "_backoffice/klb-petani/petani/$petaniId/lahan/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/": {
      "filePath": "_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/": {
      "filePath": "_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/": {
      "filePath": "_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    },
    "/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/": {
      "filePath": "_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/$verificationId/index.tsx",
      "parent": "/_backoffice"
    }
  }
}
ROUTE_MANIFEST_END */
